(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 32252:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(84443);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1405:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/pdf-grey.950162d0.svg","height":23,"width":19});

/***/ }),

/***/ 67166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const usePrevious = (value)=>{
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
};
/* harmony default export */ __webpack_exports__["Z"] = (usePrevious);


/***/ }),

/***/ 84443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ search; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 206 modules
var AemGrid = __webpack_require__(94020);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./utils/cart.js
var cart = __webpack_require__(11763);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./hooks/usePageAuth.js
var usePageAuth = __webpack_require__(48375);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx + 112 modules
var GlobalPageHeader = __webpack_require__(92058);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx
var GlobalPageFooter = __webpack_require__(10884);
;// CONCATENATED MODULE: ./components/Search/v1/SearchProgressive/index.jsx


const SearchProgressive = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "search-result",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container-fluid",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row no-gutters",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12 ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "search-result__tab-header",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "container search-result__tab-buttons",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "search-result__tab-button gbh-data-layer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "shimmer-loading__button shimmer"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "search-result__tab-button gbh-data-layer ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "shimmer-loading__button shimmer"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "search-result__tab-button gbh-data-layer ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "shimmer-loading__button shimmer"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "search-result__tab-button gbh-data-layer ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "shimmer-loading__button shimmer"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "search-result__tab-content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container product-list__container product-list__tiles",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-list__filter borderNone",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "filter__inner-container shimmer height-300"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "filter__footer",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "products-per-page width-240 mt60 mb20",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "products-per-page width-100",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-list__tile-col",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "row row-cols-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col px-1 product-list__tile",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "kf-lazyload-wrapper ",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "product-tile",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "product-tile__image",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "shimmer-loading__image shimmer"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "product-tile__details",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "width-full",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "width-full",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "product-tile__details product-tile__compare-main",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "product-tile__colors",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "product-tile__colors--count d-none d-lg-block",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col px-1 product-list__tile",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "kf-lazyload-wrapper ",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "product-tile",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "product-tile__image",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "shimmer-loading__image shimmer"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "product-tile__details",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "width-full",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "width-full",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "product-tile__details product-tile__compare-main",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "product-tile__colors",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "product-tile__colors--count d-none d-lg-block",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col px-1 product-list__tile",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "kf-lazyload-wrapper ",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "product-tile",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "product-tile__image",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "shimmer-loading__image shimmer"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "product-tile__details",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "width-full",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "width-full",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "product-tile__details product-tile__compare-main",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "product-tile__colors",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "product-tile__colors--count d-none d-lg-block",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var v1_SearchProgressive = (SearchProgressive);

;// CONCATENATED MODULE: ./public/icons/Close Icon.svg
/* harmony default export */ var Close_Icon = ({"src":"/_next/static/media/Close Icon.b99aaae5.svg","height":17,"width":17});
// EXTERNAL MODULE: ./components/Search/v1/SearchView/index.module.scss
var index_module = __webpack_require__(62860);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/Default/DynamicSearch/v1/SearchPanel/localization.js
var localization = __webpack_require__(73846);
// EXTERNAL MODULE: ./i18n/useSearchi18n.js
var useSearchi18n = __webpack_require__(81294);
;// CONCATENATED MODULE: ./components/Search/v1/OuterSearchProgressive/index.jsx








const OuterSearchProgressive = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = (0,useSearchi18n/* default */.Z)({});
    const [staticTexts] = (0,react.useState)((0,localization/* getTranslations */.F)(t));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()) === null || (index_module_default()) === void 0 ? void 0 : (index_module_default()).searchViewStyleWrapper, " Plp-Search"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "search-result",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container-fluid",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-listing__row no-gutters",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-listing__col search-result__breadcrumb-header --no-results",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "search-result__breadcrumb kf-react-plp-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                            role: "list",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    role: "listitem",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "#",
                                                            children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.globalHome
                                                        }),
                                                        " / "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    role: "listitem",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#",
                                                        children: staticText === null || staticText === void 0 ? void 0 : staticText.searchResults
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "search-result__header search-result--no-background",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "kf-react-plp-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "search-result__search-header",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "search-result__description",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        role: "alert",
                                                        "aria-live": "polite",
                                                        className: "search-result__showing --no-results",
                                                        children: [
                                                            staticText === null || staticText === void 0 ? void 0 : staticText.loading,
                                                            " ",
                                                            staticText === null || staticText === void 0 ? void 0 : staticText.results
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "search-result__search-field",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "text",
                                                            id: "search_close_button",
                                                            className: "search-result__search-control",
                                                            autoFocus: true,
                                                            placeholder: "Search Kohler"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "search-result__close-button",
                                                            role: "button",
                                                            tabIndex: "0",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: Close_Icon === null || Close_Icon === void 0 ? void 0 : Close_Icon.src,
                                                                alt: "close-icon"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_SearchProgressive, {})
                ]
            })
        })
    });
};
/* harmony default export */ var v1_OuterSearchProgressive = (OuterSearchProgressive);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./utils/index.js
var utils = __webpack_require__(20558);
// EXTERNAL MODULE: ./store/features/searchSlice.js
var searchSlice = __webpack_require__(57879);
;// CONCATENATED MODULE: ./utils/tabCountHelper.js
/**
 * Calculate total count from all tabs in tablist
 * @param {Array} tabList - Array of tab objects with id property
 * @param {Object} searchDetails - Search details object from state (newState?.searchDetails)
 * @return {number} Total count from all tabs
 */ const getTotalTabCount = function() {
    let tabList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], searchDetails = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!Array.isArray(tabList) || tabList.length === 0) {
        return 0;
    }
    return tabList.reduce((total, tab)=>{
        var ref;
        const tabCount = (searchDetails === null || searchDetails === void 0 ? void 0 : (ref = searchDetails[tab === null || tab === void 0 ? void 0 : tab.id]) === null || ref === void 0 ? void 0 : ref.count) || 0;
        return total + tabCount;
    }, 0);
};

// EXTERNAL MODULE: ./store/features/productListSlice.js
var productListSlice = __webpack_require__(49682);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/constants/colors.mjs
var colors = __webpack_require__(72531);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Navigation/Breadcrumb/Breadcrumb.mjs + 4 modules
var Breadcrumb = __webpack_require__(28763);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.mjs + 1 modules
var Grid = __webpack_require__(40697);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/GridColumn/GridColumn.mjs + 1 modules
var GridColumn = __webpack_require__(57237);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/SearchInputField/SearchInputField.mjs + 18 modules
var SearchInputField = __webpack_require__(32247);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/SearchResults/SearchResults.module.css.mjs
var classes = {
    "searchResultsContent": "bHYdz",
    "searchResultsInputField": "qUkdB"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-modules/esm/Navigation/SearchResults/SearchResults.mjs




const SearchResults = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { component ="div" , mod , breadcrumbs , searchInputField , className , copy , suggestion , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        ref,
        component,
        mod,
        ...rest,
        className: (0,clsx/* default */.Z)("kohler-search-results-root", className),
        paddingBottom: 40,
        backgroundColor: colors/* DsmColor.BackgroundPrimary */.k.BackgroundPrimary
    }, breadcrumbs && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Breadcrumb/* Breadcrumb */.a, {
        transparent: false,
        breadcrumbs
    }), /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        rowGap: 15
    }, (copy || suggestion) && /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        fullWidth: false,
        className: classes.searchResultsContent
    }, copy && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "h6",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        ...(0,helpers/* omitText */.rW)(copy),
        component: /*#__PURE__*/ (0,react.isValidElement)(copy.text) ? "div" : copy.component || "p"
    }, copy.text), suggestion && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-regular-m",
        textColor: colors/* DsmColor.ContentSecondary */.k.ContentSecondary,
        ...(0,helpers/* omitText */.rW)(suggestion)
    }, suggestion.text)), /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        fullWidth: false,
        className: classes.searchResultsInputField
    }, searchInputField && /* @__PURE__ */ /*#__PURE__*/ react.createElement(SearchInputField/* SearchInputField */.Q, {
        ...searchInputField,
        size: "small"
    }))));
});


;// CONCATENATED MODULE: ./components/Search/v1/SearchView/index.jsx










const PopularSearch = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9562), __webpack_require__.e(1261)]).then(__webpack_require__.bind(__webpack_require__, 91261)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(91261)
            ]
    }
});
const NoResultLinks = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9562), __webpack_require__.e(2192)]).then(__webpack_require__.bind(__webpack_require__, 52192)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(52192)
            ]
    }
});





const SearchComponentView = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    const { data , brand ="" , loadPopularSearch , activeTabVal , tabList , searchKeyword , staticTexts , totalResults , onSearch , loading , searchResponse , isSterling =false  } = props;
    const { home ="" , searchResults ="" , searchBrand ="" , noResults ="" , searchInstead ="" , noResultsSuggest ="" , ariaLabel =""  } = staticTexts;
    const dispatch = (0,es/* useDispatch */.I0)();
    const searchRef = (0,react.useRef)(null);
    const newState = (0,es/* useSelector */.v9)(searchSlice/* searchState */.uv);
    const { noResultPopularTopicsHeading ="" , noResultPopularLinks =[] , noResultOurSuggestionsHeading ="" , noResultOurSuggestionsSubcopy =""  } = data;
    const [activeTab, setActiveTab] = (0,react.useState)(activeTabVal ? activeTabVal < 0 ? 0 : activeTabVal : newState === null || newState === void 0 ? void 0 : (ref = newState.searchDetails) === null || ref === void 0 ? void 0 : ref.activeTab) // while refresh keep select the same tab
    ;
    const [homePagePath, setHomePagePath] = (0,react.useState)("");
    const [searchPlaceholder, setSearchplaceholder] = (0,react.useState)(brand);
    const [inputValueChange, setInputValueChange] = (0,react.useState)(searchKeyword || "");
    const [typeAheadResults, setTypeaheadResults] = (0,react.useState)([]);
    const [forceTabLoader, setForceTabLoader] = (0,react.useState)(false);
    const [refreshTrigger, setRefreshTrigger] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        var ref;
        setInputValueChange(newState === null || newState === void 0 ? void 0 : (ref = newState.searchDetails) === null || ref === void 0 ? void 0 : ref.keyword);
    }, [
        newState === null || newState === void 0 ? void 0 : (ref1 = newState.searchDetails) === null || ref1 === void 0 ? void 0 : ref1.keyword
    ]);
    let isSpellTagged = false;
    let resultsText = "";
    let keepSearching = "";
    let currTab = activeTab ? Number(activeTab) : 0 // required for ADA focus
    ;
    // Calculate total count from all tabs
    const calculatedTotalResults = getTotalTabCount(tabList, newState === null || newState === void 0 ? void 0 : newState.searchDetails);
    const setCount = ()=>{
        const counts = {};
        tabList === null || tabList === void 0 ? void 0 : tabList.forEach((tab)=>{
            var ref;
            counts[tab === null || tab === void 0 ? void 0 : tab.id] = {
                count: tab === null || tab === void 0 ? void 0 : tab.count
            };
            if (searchKeyword !== (newState === null || newState === void 0 ? void 0 : (ref = newState.searchDetails) === null || ref === void 0 ? void 0 : ref.keyword)) {
                dispatch((0,searchSlice/* setSearchFilter */.Qf)({
                    queries: [],
                    key: tab === null || tab === void 0 ? void 0 : tab.id
                }));
            }
        });
        dispatch((0,searchSlice/* setSearchCount */.kj)(counts));
    };
    (0,react.useEffect)(()=>{
        // Will trigger only when tab keyword is available in url.
        if (activeTabVal !== undefined) {
            setActiveTab(activeTabVal);
        }
    }, [
        activeTabVal
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        (ref = (0,config/* getConfig */.i)()) === null || ref === void 0 ? void 0 : ref.then((config)=>{
            var ref, ref1, ref2, ref3;
            var ref4;
            const searchBrandPlaceholder = (ref4 = config === null || config === void 0 ? void 0 : (ref = config.apiEndPointData) === null || ref === void 0 ? void 0 : (ref1 = ref.map) === null || ref1 === void 0 ? void 0 : ref1.searchBrandPlaceholder) !== null && ref4 !== void 0 ? ref4 : brand;
            if ((searchBrandPlaceholder === null || searchBrandPlaceholder === void 0 ? void 0 : searchBrandPlaceholder.length) > 0) {
                setSearchplaceholder(searchBrandPlaceholder);
            }
            var ref5;
            (ref3 = (0,helper/* getShortenedUrl */.Ppy)((ref5 = config === null || config === void 0 ? void 0 : (ref2 = config.general) === null || ref2 === void 0 ? void 0 : ref2.homepageUrl) !== null && ref5 !== void 0 ? ref5 : "/")) === null || ref3 === void 0 ? void 0 : ref3.then((res)=>setHomePagePath(res));
        });
        setCount();
    }, []);
    (0,react.useEffect)(()=>{
        if (loading) {
            setCount();
        }
    }, [
        searchKeyword,
        loading
    ]);
    (0,react.useEffect)(()=>{
        if (activeTab < 0) {
            setActiveTab(0);
        }
        if ((tabList === null || tabList === void 0 ? void 0 : tabList.length) <= (activeTab ? Number(activeTab) : 0)) {
            setActiveTab(0);
        }
    }, [
        activeTab,
        tabList === null || tabList === void 0 ? void 0 : tabList.length
    ]);
    if ((searchResponse === null || searchResponse === void 0 ? void 0 : (ref2 = searchResponse.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fusion) === null || ref3 === void 0 ? void 0 : ref3.tagger) && (searchResponse === null || searchResponse === void 0 ? void 0 : (ref4 = searchResponse.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.fusion) === null || ref5 === void 0 ? void 0 : ref5.tagger[0]) && ((ref8 = searchResponse === null || searchResponse === void 0 ? void 0 : (ref6 = searchResponse.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fusion) === null || ref7 === void 0 ? void 0 : ref7.tagger[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.tag) === null || ref9 === void 0 ? void 0 : ref9.type) === "spell") {
        var ref14, ref15, ref16, ref17, ref18, ref19;
        isSpellTagged = true;
        keepSearching = (ref16 = searchResponse === null || searchResponse === void 0 ? void 0 : (ref14 = searchResponse.data) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.fusion) === null || ref15 === void 0 ? void 0 : ref15.tagger[0]) === null || ref16 === void 0 ? void 0 : ref16.surfaceForm;
        resultsText = "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.showing, " ").concat(calculatedTotalResults === null || calculatedTotalResults === void 0 ? void 0 : calculatedTotalResults.toLocaleString(), " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.results, " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.for, ' "').concat((ref19 = searchResponse === null || searchResponse === void 0 ? void 0 : (ref17 = searchResponse.data) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.fusion) === null || ref18 === void 0 ? void 0 : ref18.tagger[0]) === null || ref19 === void 0 ? void 0 : ref19.outputForms[0], '"');
    } else if ((searchResponse === null || searchResponse === void 0 ? void 0 : (ref10 = searchResponse.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.fusion) === null || ref11 === void 0 ? void 0 : ref11.autoCorrectQuery) && (searchResponse === null || searchResponse === void 0 ? void 0 : (ref12 = searchResponse.data) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.fusion) === null || ref13 === void 0 ? void 0 : ref13.org_q) && !isSterling) {
        var ref20, ref21, ref22, ref23;
        isSpellTagged = true;
        keepSearching = searchResponse === null || searchResponse === void 0 ? void 0 : (ref20 = searchResponse.data) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.fusion) === null || ref21 === void 0 ? void 0 : ref21.org_q;
        resultsText = "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.showing, " ").concat(calculatedTotalResults === null || calculatedTotalResults === void 0 ? void 0 : calculatedTotalResults.toLocaleString(), " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.results, " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.for, ' "').concat(searchResponse === null || searchResponse === void 0 ? void 0 : (ref22 = searchResponse.data) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.fusion) === null || ref23 === void 0 ? void 0 : ref23.autoCorrectQuery, '"');
    } else {
        resultsText = "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.showing, " ").concat(calculatedTotalResults === null || calculatedTotalResults === void 0 ? void 0 : calculatedTotalResults.toLocaleString(), " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.results, " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.for, ' "').concat(searchKeyword, '"');
    }
    const changeTab = (tab)=>{
        var ref, ref1, ref2;
        // Check if clicking the already active tab
        if (tab === activeTab) {
            // Increment counter to force child component to re-fetch
            dispatch((0,productListSlice/* clearProductData */.sR)());
            setForceTabLoader(true);
            setActiveTab(tab);
            setRefreshTrigger((prev)=>prev + 1);
            dispatch((0,searchSlice/* setActiveTabDispatch */.az)(tab));
            setTimeout(()=>{
                setForceTabLoader(false);
            }, 750);
            return; // Exit early, no need to update state or URL
        }
        // Clear product data immediately for faster tab switching
        dispatch((0,productListSlice/* clearProductData */.sR)());
        setActiveTab(tab);
        dispatch((0,searchSlice/* setActiveTabDispatch */.az)(tab));
        // Force show TabLoader for 750ms on tab change
        setForceTabLoader(true);
        setTimeout(()=>{
            setForceTabLoader(false);
        }, 750);
        const query = window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.search;
        const currentTab = tabList[tab];
        if (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("SRPTabDetails")) {
            const srpTabDetails = JSON.parse(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("SRPTabDetails"));
            const storedUrl = srpTabDetails[currentTab === null || currentTab === void 0 ? void 0 : currentTab.id];
            if (storedUrl) {
                // Add the correct tab parameter for the active tab
                const urlParams = new URLSearchParams(storedUrl.replace("?", ""));
                urlParams.set("tab", currentTab === null || currentTab === void 0 ? void 0 : currentTab.id);
                const urlWithCorrectTab = "?".concat(urlParams.toString());
                // Debounce tab URL updates to prevent Safari crashes
                if (window.__tabUrlUpdateTimeout) {
                    clearTimeout(window.__tabUrlUpdateTimeout);
                }
                window.__tabUrlUpdateTimeout = setTimeout(()=>{
                    try {
                        var ref;
                        history === null || history === void 0 ? void 0 : history.replaceState(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname, document === null || document === void 0 ? void 0 : document.title, urlWithCorrectTab);
                    } catch (err) {
                        // eslint-disable-next-line no-console
                        console.warn("Failed to update tab URL:", err.message);
                    }
                }, 100) // 100ms debounce for tab switches
                ;
            } else (0,helper/* resetUrl */.eRK)();
        } else if (query) (0,helper/* resetUrl */.eRK)();
        if ((newState === null || newState === void 0 ? void 0 : (ref1 = newState.searchDetails) === null || ref1 === void 0 ? void 0 : ref1.keyword) && (newState === null || newState === void 0 ? void 0 : (ref2 = newState.searchDetails) === null || ref2 === void 0 ? void 0 : ref2.keyword) !== searchKeyword) {
            setCount();
        }
        if (searchKeyword === "") {
            var ref3;
            const urlParams1 = new URLSearchParams(window === null || window === void 0 ? void 0 : (ref3 = window.location) === null || ref3 === void 0 ? void 0 : ref3.search);
            const keyword = urlParams1 === null || urlParams1 === void 0 ? void 0 : urlParams1.get("keyword");
            onSearch(keyword);
        }
    };
    // In your tab content component (Products/Articles/etc.)
    (0,react.useEffect)(()=>{
        // This will trigger when refreshTrigger changes
        if (refreshTrigger) onSearch(searchKeyword);
    }, [
        refreshTrigger
    ]);
    const handleSearchEnterNew = ()=>{
        onSearch(inputValueChange);
    };
    const handleKeyPress = (e)=>{
        if (e.keyCode === 37 || e.keyCode === 39) {
            var ref, ref1;
            if (e.keyCode === 37) {
                currTab = currTab - 1;
            } else if (e.keyCode === 39) {
                currTab = currTab + 1;
            }
            if (currTab < 0) currTab = (tabList === null || tabList === void 0 ? void 0 : tabList.length) - 1;
            if (currTab >= (tabList === null || tabList === void 0 ? void 0 : tabList.length)) currTab = 0;
            (ref1 = document.getElementById("".concat((ref = tabList[currTab]) === null || ref === void 0 ? void 0 : ref.title, "-tab"))) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    };
    (0,react.useEffect)(()=>{
        const fetchTypeahead = async ()=>{
            try {
                var ref, ref1, ref2;
                const response = await dispatch((0,productListSlice/* profileBrandTypeahead */.zw)([
                    inputValueChange,
                    brand.toLowerCase()
                ]));
                const transformedResults = (response === null || response === void 0 ? void 0 : (ref = response.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.docs) === null || ref2 === void 0 ? void 0 : ref2.map((doc)=>({
                        label: doc.productName_s,
                        value: doc.productName_s
                    }))) || [];
                inputValueChange.length > 2 && setTypeaheadResults(transformedResults);
                if (inputValueChange.length < 3) setTypeaheadResults([]);
            } catch (error) {
                console.error("Error fetching typeahead:", error);
            }
        };
        if (inputValueChange) {
            fetchTypeahead();
        }
    }, [
        inputValueChange,
        brand,
        dispatch
    ]);
    const handleBreadcrumbClick = (e)=>{
        const target = e.target.closest('[data-datalayer-id="search-breadcrumb"]');
        if (target) {
            var ref, ref1;
            const rawEventInfo = JSON.parse((target === null || target === void 0 ? void 0 : (ref = target.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref["data-datalayer-data"]) === null || ref1 === void 0 ? void 0 : ref1.nodeValue) || "{}");
            const page = window.pageObj || {};
            // Common attributes to add to all events
            const commonEventInfo = {
                eventAction: rawEventInfo.eventAction || "search:breadcrumb",
                eventType: rawEventInfo.eventType || "navigation",
                eventName: rawEventInfo.eventName || "search:breadcrumb",
                internalLinkPosition: (rawEventInfo === null || rawEventInfo === void 0 ? void 0 : rawEventInfo.internalLinkPosition) || "search",
                internalLinkZoneName: (rawEventInfo === null || rawEventInfo === void 0 ? void 0 : rawEventInfo.internalLinkZoneName) || "search:search box",
                internalLinkType: (rawEventInfo === null || rawEventInfo === void 0 ? void 0 : rawEventInfo.internalLinkType) || "search:breadcrumb"
            };
            // Merge common attributes with specific event info
            const eventInfo = {
                ...rawEventInfo,
                ...commonEventInfo
            };
            window.adobeDataLayer = window.adobeDataLayer || [];
            window.adobeDataLayer.push({
                event: "cmp:click",
                page,
                eventInfo
            });
        }
    };
    (0,react.useEffect)(()=>{
        document.addEventListener("click", handleBreadcrumbClick);
        return ()=>document.removeEventListener("click", handleBreadcrumbClick);
    }, []);
    const breadcrumbEventInfo = (type)=>{
        var ref;
        const homeBreadcrumb = (type === null || type === void 0 ? void 0 : type.toLowerCase()) === "home";
        return JSON.stringify({
            eventAction: "search:breadcrumb",
            eventName: "search:breadcrumb",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: homeBreadcrumb ? "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.home) : "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.home, " > ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.searchResults),
            internalLinkPosition: "search",
            internalLinkType: "search:breadcrumb",
            internalLinkZoneName: "search:search box",
            internalLinkURL: homeBreadcrumb ? "".concat(homePagePath) : "".concat(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href),
            clickInternalLinks: "true"
        });
    };
    const searchResultsContent = {
        mod: "white",
        breadcrumbs: [
            {
                href: homePagePath,
                text: home,
                trackingAttributes: {
                    "data-datalayer-id": "search-breadcrumb",
                    "data-datalayer-data": breadcrumbEventInfo(home)
                }
            },
            {
                text: searchResults,
                href: "#",
                trackingAttributes: {
                    "data-datalayer-id": "search-breadcrumb",
                    "data-datalayer-data": breadcrumbEventInfo(searchResults)
                }
            }
        ],
        searchInputField: {
            id: "search-result-input",
            label: "Search Kohler",
            ref: searchRef,
            value: inputValueChange,
            onChange: (e)=>{
                setInputValueChange(e.target.value);
            },
            onKeyDown: (e)=>(e.key === "Enter" || e.keyCode === 13) && handleSearchEnterNew(),
            placeholder: "".concat(searchBrand, " ").concat(searchPlaceholder),
            searchCTA: {
                text: "Search",
                onClick: ()=>onSearch(inputValueChange)
            },
            clearCTA: {
                onClick: ()=>{
                    setInputValueChange("");
                }
            },
            filteredResults: typeAheadResults,
            results: {
                options: typeAheadResults,
                onOptionSubmit: (e)=>{
                    onSearch(e.value, inputValueChange, "FROM TYPEAHEAD SUGGESTION");
                }
            }
        },
        copy: totalResults > 0 ? {
            text: loading ? "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.loading, " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.results) : totalResults === 0 ? noResults : resultsText
        } : undefined,
        suggestion: totalResults > 0 ? {
            text: !loading && isSpellTagged === true && (searchKeyword === null || searchKeyword === void 0 ? void 0 : searchKeyword.length) > 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "search-result__instead",
                children: [
                    searchInstead,
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: ()=>onSearch(keepSearching, true, true),
                        children: keepSearching
                    })
                ]
            })
        } : undefined
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((index_module_default()) === null || (index_module_default()) === void 0 ? void 0 : (index_module_default()).searchViewStyleWrapper, " Plp-Search"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "search-result",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container-fluid",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-listing__row no-gutters",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-listing__col search-result__breadcrumb-header ".concat(totalResults === 0 ? " --no-results" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "search-landing",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults, {
                                            ...searchResultsContent
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "search-result__description search-no-resultes",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                role: "alert",
                                                "aria-live": "polite",
                                                className: "search-result__showing ".concat(totalResults === 0 ? " --no-results" : ""),
                                                children: totalResults === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "search-result__no-results",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: noResults
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: noResultsSuggest
                                                        })
                                                    ]
                                                }) : ""
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_SearchProgressive, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row no-gutters",
                            children: !loading && (totalResults > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "search-result__tab-header",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "container search-result__tab-buttons kf-react-container",
                                            role: "tablist",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "d-flex",
                                                children: tabList === null || tabList === void 0 ? void 0 : tabList.map((tab, i)=>{
                                                    var ref, ref1;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        id: "".concat(tab === null || tab === void 0 ? void 0 : tab.title, "-tab"),
                                                        "aria-label": ariaLabel === null || ariaLabel === void 0 ? void 0 : ariaLabel.tabs((ref = newState === null || newState === void 0 ? void 0 : newState.searchDetails[tab === null || tab === void 0 ? void 0 : tab.id]) === null || ref === void 0 ? void 0 : ref.count, tab === null || tab === void 0 ? void 0 : tab.title),
                                                        "aria-selected": (activeTab ? Number(activeTab) : 0) === i ? true : false,
                                                        role: "tab",
                                                        "data-gbh-data-layer": '{"eventAction":"search results:hero:inner tabs","eventName":"search results:hero:inner tabs","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"'.concat(tab === null || tab === void 0 ? void 0 : tab.title, '","internalLinkPosition":"search","internalLinkType":"search results:navigation","internalLinkZoneName":"search results:hero","internalLinkURL":"n/a","clickInternalLinks":"true"}'),
                                                        className: "search-result__tab-button gbh-data-layer ".concat((activeTab ? Number(activeTab) : 0) === i ? "--active" : ""),
                                                        onClick: ()=>changeTab(i),
                                                        onKeyDown: (e)=>handleKeyPress(e),
                                                        tabIndex: (activeTab ? Number(activeTab) : 0) === i ? 0 : -1,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            role: "heading",
                                                            "aria-level": "2",
                                                            children: "".concat(tab === null || tab === void 0 ? void 0 : tab.title, " (").concat((ref1 = newState === null || newState === void 0 ? void 0 : newState.searchDetails[tab === null || tab === void 0 ? void 0 : tab.id]) === null || ref1 === void 0 ? void 0 : ref1.count, ")")
                                                        })
                                                    }, i);
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "search-result__tab-content",
                                        children: /*#__PURE__*/ react.cloneElement(get_default()(tabList[activeTab ? Number(activeTab) : 0], "content", ""), {
                                            forceTabLoader,
                                            refreshTrigger
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "search-result__no-result",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-lg-4 col-sm-12 search-result__no-result-column",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "search-result__suggestions-title wow animate__slideInLeft",
                                                        children: noResultOurSuggestionsHeading
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "search-result__suggestions-list wow animate__fadeInUp",
                                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(noResultOurSuggestionsSubcopy)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-lg-4 col-sm-12 search-result__no-result-column",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularSearch, {
                                                    staticTexts: staticTexts,
                                                    loadPopularSearch: loadPopularSearch,
                                                    brand: brand,
                                                    updateFromResult: onSearch,
                                                    staticData: data
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-lg-4 col-sm-12 search-result__no-result-column",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResultLinks, {
                                                    data: noResultPopularLinks,
                                                    link: true,
                                                    heading: noResultPopularTopicsHeading
                                                })
                                            })
                                        ]
                                    })
                                })
                            }))
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var SearchView = (SearchComponentView);

// EXTERNAL MODULE: ./components/Search/v1/InspirationTab/index.jsx
var InspirationTab = __webpack_require__(40577);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-lazy-load/dist/LazyLoad.js
var LazyLoad = __webpack_require__(25043);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./hooks/usePrevious.js
var usePrevious = __webpack_require__(67166);
// EXTERNAL MODULE: ./components/Search/v1/ProductsTab/helper.js
var ProductsTab_helper = __webpack_require__(34955);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./components/Search/v1/TechnicalTile/index.jsx + 2 modules
var TechnicalTile = __webpack_require__(97184);
// EXTERNAL MODULE: ./components/ProductList/v2/Filter/index.jsx + 5 modules
var Filter = __webpack_require__(50772);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductListView/Pagination/index.jsx
var Pagination = __webpack_require__(70487);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductListView/StickyNav/stickyNavHeader.jsx + 1 modules
var stickyNavHeader = __webpack_require__(24751);
;// CONCATENATED MODULE: ./components/Search/v1/TabLoader/index.jsx


const TabLoader = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "search-result__tab-content",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container product-list__container product-list__tiles",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-list__filter borderNone",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "filter__inner-container shimmer height-300"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "filter__footer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "products-per-page width-240 mt60 mb20",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "shimmer-loading__headpara shimmer"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "products-per-page width-100",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "shimmer-loading__para shimmer"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-list__tile-col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row row-cols-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col px-1 product-list__tile",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "kf-lazyload-wrapper ",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "product-tile",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-tile__image",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "shimmer-loading__image shimmer"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "product-tile__details",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-tile__details product-tile__compare-main",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__colors",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "product-tile__colors--count d-none d-lg-block",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "shimmer-loading__para shimmer width-full"
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col px-1 product-list__tile",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "kf-lazyload-wrapper ",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "product-tile",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-tile__image",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "shimmer-loading__image shimmer"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "product-tile__details",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-tile__details product-tile__compare-main",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__colors",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "product-tile__colors--count d-none d-lg-block",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "shimmer-loading__para shimmer width-full"
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col px-1 product-list__tile",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "kf-lazyload-wrapper ",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "product-tile",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-tile__image",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "shimmer-loading__image shimmer"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "product-tile__details",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-tile__details product-tile__compare-main",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__colors",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "product-tile__colors--count d-none d-lg-block",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "shimmer-loading__para shimmer width-full"
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col px-1 product-list__tile",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "kf-lazyload-wrapper ",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "product-tile",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-tile__image",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "shimmer-loading__image shimmer"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "product-tile__details",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-tile__details product-tile__compare-main",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__colors",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "product-tile__colors--count d-none d-lg-block",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "shimmer-loading__para shimmer width-full"
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col px-1 product-list__tile",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "kf-lazyload-wrapper ",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "product-tile",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-tile__image",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "shimmer-loading__image shimmer"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "product-tile__details",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-tile__details product-tile__compare-main",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__colors",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "product-tile__colors--count d-none d-lg-block",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "shimmer-loading__para shimmer width-full"
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col px-1 product-list__tile",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "kf-lazyload-wrapper ",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "product-tile",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-tile__image",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "shimmer-loading__image shimmer"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "product-tile__details",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "product-tile__details product-tile__compare-main",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-tile__colors",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: "product-tile__colors--count d-none d-lg-block",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            className: "shimmer-loading__para shimmer width-full"
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var v1_TabLoader = (TabLoader);

// EXTERNAL MODULE: ./components/ProductList/v2/ProductListView/index.module.scss
var ProductListView_index_module = __webpack_require__(29472);
var ProductListView_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductListView_index_module);
// EXTERNAL MODULE: ./components/ProductList/v2/Sort/index.module.scss
var Sort_index_module = __webpack_require__(19806);
var Sort_index_module_default = /*#__PURE__*/__webpack_require__.n(Sort_index_module);
// EXTERNAL MODULE: ./components/ProductList/v2/Filter/index.module.scss
var Filter_index_module = __webpack_require__(3899);
var Filter_index_module_default = /*#__PURE__*/__webpack_require__.n(Filter_index_module);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./components/Search/v1/TechnicalTab/index.jsx


























const TechnicalTab = (props)=>{
    var ref, ref1;
    const { totalResults =0 , searchKeyword ="" , displayPrint , displayShare , page ="" , staticTexts ={} , onSearch =()=>{} , productsPerPage , type ="" , marketParamValues =[] , count =0 , forceTabLoader =false , brand =""  } = props;
    const [width] = (0,useWindowResize/* default */.Z)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const { isLandscape  } = props;
    const [showFilter, setShowFilter] = (0,react.useState)(width >= 1024 ? true : false);
    const [rowCols, setRowCols] = (0,react.useState)(width < 1024 ? 1 : 3);
    const [curRows, setCurRows] = (0,react.useState)(30);
    const [start, setStart] = (0,react.useState)(0);
    const filterModalWindow = (0,react.useRef)(null);
    const [selectedSort, setSelectedSort] = (0,react.useState)({});
    const [filterQueries, setFilterQueries] = (0,react.useState)([]);
    const [siteName, setSiteName] = (0,react.useState)();
    const [dataPopulated, setDataPopulated] = (0,react.useState)(false);
    var ref2;
    const [scrollToSku, setScrollToSku] = (0,react.useState)((ref2 = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.plpScrollSku) !== null && ref2 !== void 0 ? ref2 : "");
    const [isFusionLoaded, setIsFusionLoaded] = (0,react.useState)(false);
    const prevRows = (0,usePrevious/* default */.Z)(curRows);
    const [isLoadMore, setIsLoadMore] = (0,react.useState)(false);
    const [isRendering, setIsRendering] = (0,react.useState)(true);
    const { searchDetails ={} , searchResponse: { data: { fusion: searchFusion = {}  } = {}  } = {}  } = (0,es/* useSelector */.v9)(searchSlice/* searchState */.uv);
    const { data =[] , total , facets ={} , facetLabels , colors , status  } = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv).plp;
    const { access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const retainedFilters = searchDetails.keyword === searchKeyword && ((ref = searchDetails[type]) === null || ref === void 0 ? void 0 : ref.filters) ? searchDetails[type].filters : [];
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then(async (config)=>{
            const brandName = get_default()(config, "general.siteName");
            setSiteName(brandName);
        });
        const selectedSortItem = (0,helper/* getSortItemBasedOnURL */.KE)(staticTexts, {
            name: "Featured"
        });
        setSelectedSort(selectedSortItem);
    }, []);
    (0,react.useEffect)(()=>{
        if (status !== "loading" || data.length > 0) {
            setIsRendering(false);
        }
    }, [
        status,
        data
    ]);
    const filterClass = classnames_default()({
        "product-listing__filter": true,
        "product-listing__filter--hide": !lib/* isTablet */.Em && !lib/* isMobile */.tq || width > 992 ? !showFilter : false,
        "product-listing__filter--modal": lib/* isTablet */.Em || lib/* isMobile */.tq || width < 992 ? showFilter : false
    });
    const tileClass = classnames_default()({
        "product-listing__tile-col": true,
        "product-listing__tile-col--full-width": !lib/* isTablet */.Em && !lib/* isMobile */.tq || width > 992 ? !showFilter : true
    });
    const sorts = [
        {
            name: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.featured
        },
        {
            name: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.atoz,
            query: "productName_s+asc"
        },
        {
            name: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.ztoa,
            query: "productName_s+desc"
        }
    ];
    const searchResultDataLayerObj = {
        searchResult: totalResults,
        searchTerm: searchKeyword,
        searchResultCategoryType: type === null || type === void 0 ? void 0 : type.toLowerCase(),
        searchResultCategoryTypeCount: count
    };
    const executeScroll = ()=>{
        modules/* scroller.scrollTo */.OK.scrollTo("products-tab", {
            duration: 1500,
            delay: 0,
            smooth: "easeInOutQuart"
        });
    };
    (0,react.useEffect)(()=>{
        lib/* isTablet */.Em ? window.outerWidth >= 1024 ? setRowCols(3) : setRowCols(2) : lib/* isMobile */.tq ? isLandscape ? setRowCols(2) : setRowCols(2) : setRowCols(3);
    }, [
        isLandscape,
        width
    ]);
    (0,react.useEffect)(()=>{
        if (accessToken && filterQueries != null) {
            if (start) {
                generateListingUrl(isLoadMore, false);
            } else if (start === 0 && scrollToSku) {
                setScrollToSku("");
                generateListingUrl(false, true);
            } else if (start === 0 && curRows && !!prevRows && prevRows > curRows) {
                generateListingUrl(false, true);
            } else if (start === 0 && curRows) {
                generateListingUrl(false, false);
            }
        }
    }, [
        accessToken,
        start,
        curRows,
        selectedSort,
        filterQueries
    ]);
    (0,react.useEffect)(()=>{
        switch(true){
            case width > 1024:
                setRowCols(1);
                break;
            case width < 668:
                setRowCols(1);
                break;
            default:
                setRowCols(1);
        }
    }, [
        isLandscape,
        width
    ]);
    (0,react.useEffect)(()=>{
        if (dataPopulated) (0,ProductsTab_helper/* scrollToProduct */.C1)();
    }, [
        dataPopulated
    ]);
    (0,react.useEffect)(()=>{
        if (showFilter && (width < 992 || lib/* isMobile */.tq || lib/* isTablet */.Em)) {
            var ref;
            filterModalWindow === null || filterModalWindow === void 0 ? void 0 : (ref = filterModalWindow.current) === null || ref === void 0 ? void 0 : ref.focus();
        } else if (!showFilter && (width < 992 || lib/* isMobile */.tq || lib/* isTablet */.Em)) {
            var ref1;
            (ref1 = document.getElementById("showFilter")) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    }, [
        showFilter
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(searchFusion) && accessToken && !isFusionLoaded) {
            setIsFusionLoaded(true);
            if (retainedFilters.length > 0) {
                setFilterQueries(retainedFilters);
            } else {
                const filterQuery = (0,helper/* getAllFilterQueries */.ud4)({
                    attributeName: ""
                }, searchFusion, marketParamValues);
                setFilterQueries(filterQuery);
                dispatch((0,searchSlice/* setSearchFilter */.Qf)({
                    queries: filterQuery,
                    key: type
                }));
                (0,helper/* retainSearchQueryParams */.mSA)(type);
            }
        }
    }, [
        searchFusion,
        accessToken
    ]);
    const onRows = (rows)=>{
        setStart(0);
        setCurRows(rows);
    };
    const onLoadMore = ()=>{
        setIsLoadMore(true);
        setStart(start + curRows);
    };
    const onSort = (query)=>{
        setStart(0);
        (0,helper/* replaceSearchUrl */.CjH)("sort", query === null || query === void 0 ? void 0 : query.query);
        (0,helper/* replaceSearchUrl */.CjH)("tab", type);
        (0,helper/* retainSearchQueryParams */.mSA)(type);
        setSelectedSort(query);
    };
    const generateListingUrl = function(update) {
        let enableScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, queries = arguments.length > 2 ? arguments[2] : void 0;
        let callStart = 0;
        const persona = (0,helper/* getUserPersona */.shu)();
        if (!queries && retainedFilters.length > 0) {
            setFilterQueries(retainedFilters);
            queries = retainedFilters;
        } else {
            queries = filterQueries;
            callStart = start;
            dispatch((0,searchSlice/* setSearchFilter */.Qf)({
                queries: filterQueries,
                key: type
            }));
        }
        const fq = [
            'Technical:("Yes")'
        ];
        queries === null || queries === void 0 ? void 0 : queries.forEach((q)=>fq.push("".concat(q.facet, ':("').concat(encodeURIComponent(q.value.join('","')), '")')));
        const query = {
            fq,
            rows: curRows,
            start: callStart
        };
        if (selectedSort.name !== staticTexts.featured) {
            if (selectedSort.name) {
                query.sort = selectedSort.query;
            }
        }
        const fl = [
            "id",
            "slug_s",
            "masterSKU_s",
            "masterCustomerFacingSKU_s",
            "productName_s",
            "Product_Category",
            "productImages.url_ss",
            "ProductSustainability_s",
            "ProductBrandName_s",
            "ProductADACompliant_s",
            "ProductBrandNameDisplay_s",
            "ProductDescriptionProductShort_s",
            "ProductResource.DXFPlanView.resourceFullWebURL_ss",
            "ProductResource.DWGPlanView.resourceFullWebURL_ss",
            "ProductResource.DXFFrontView.resourceFullWebURL_ss",
            "ProductResource.DWGFrontView.resourceFullWebURL_ss",
            "ProductResource.DXFSideView.resourceFullWebURL_ss",
            "ProductResource.DWGSideView.resourceFullWebURL_ss",
            "ProductResource.3DDXFSymbol.resourceFullWebURL_ss",
            "ProductResource.3DDWGSymbol.resourceFullWebURL_ss",
            "ProductResource.3DRevit.resourceFullWebURL_ss",
            "ProductResource.3D3DS.resourceFullWebURL_ss",
            "ProductResource.3DSketchup.resourceFullWebURL_ss",
            "ProductResource.CutOutDXF.resourceFullWebURL_ss",
            "ProductResource.3DOBJ.resourceFullWebURL_ss",
            "ProductResource.SpecPDFFileName.resourceFullWebURL_ss",
            "ProductResource.SpecPDFFileName.resourceTitle_ss",
            "ProductResource.EnvironProdDecl.resourceFullWebURL_ss",
            "ProductResource.EnvironProdDecl.resourceTitle_ss",
            "ProductResource.HomeownersGuide.resourceFullWebURL_ss",
            "ProductResource.HomeownersGuide.resourceTitle_ss",
            "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
            "ProductResource.InstallationWithoutSPPDF.resourceTitle_ss",
            "ProductIsRetail",
            "comboSKUAvailable_b",
            "ProductResource.InteractiveSVG.resourceTitle_ss",
            "ProductResource.InteractiveSVG.resourceName_ss",
            "ProductProductNo_s",
            "category1_s",
            "priceList.".concat(persona, ".finalPrice_d"),
            "priceList.".concat(persona, ".discountedPrice_d"),
            "priceList.".concat(persona, ".saleOffer_s"),
            "priceStartingAt.".concat(persona, "_d"),
            "discountedPriceStartingAt.".concat(persona, "_d"),
            "Tile_Title",
            "ProductBadgeInfo_ss"
        ];
        const queryParams = {
            q: searchKeyword,
            fl: fl.join(","),
            ...query,
            displaytype: "search",
            update
        };
        if (enableScroll) setDataPopulated(false);
        dispatch((0,productListSlice/* getProducts */.Xp)({
            ...queryParams
        })).unwrap().then((obj)=>{
            if (enableScroll) setDataPopulated(true);
            // Update the count in Redux searchDetails for this tab
            if (obj && (obj === null || obj === void 0 ? void 0 : obj.data) && obj.data.total !== undefined) {
                dispatch((0,searchSlice/* setSearchTabCount */.u1)({
                    tabType: type,
                    count: obj.data.total
                }));
            }
        }).catch(()=>{
            if (enableScroll) setDataPopulated(false);
        });
    };
    const handleKeyPress = (e)=>{
        if (width < 992) {
            var ref;
            const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]) [role="button]:not([hidden=true])';
            const focusContent = filterModalWindow === null || filterModalWindow === void 0 ? void 0 : (ref = filterModalWindow.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll(focusElements);
            const firstElem = focusContent[0];
            const lastElem = focusContent[focusContent.length - 1].disabled ? focusContent[focusContent.length - 2] : focusContent[focusContent.length - 1];
            if (e.key === "Escape") {
                setShowFilter(false);
            }
            if (e.key === "Tab") {
                if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === filterModalWindow.current)) {
                    e.preventDefault();
                    lastElem.focus();
                }
                if (!e.shiftKey && document.activeElement === lastElem) {
                    e.preventDefault();
                    firstElem.focus();
                }
            }
        }
    };
    const handleBackToTop = ()=>{
        var ref;
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        (ref = document.getElementById("kf-product-list-tile-details-0")) === null || ref === void 0 ? void 0 : ref.focus();
    };
    const handleFilter = (queries)=>{
        setIsLoadMore(false);
        dispatch((0,searchSlice/* setSearchFilter */.Qf)({
            queries,
            key: type
        }));
        setFilterQueries(queries);
        (0,ProductsTab_helper/* scrollToFirstProduct */.nj)();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((ProductListView_index_module_default()).productListWrapper, " ").concat((Sort_index_module_default()).productListingSearchWrapper, " ").concat((Filter_index_module_default()).productListingFilterWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "product-listing productListing_technical",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(stickyNavHeader["default"], {
                    showFilter: showFilter,
                    rowCols: rowCols,
                    setShowFilter: setShowFilter,
                    setRowCols: setRowCols,
                    staticTexts: staticTexts,
                    sorts: sorts,
                    selectedSort: selectedSort,
                    handleSort: onSort,
                    totalResults: ((ref1 = searchDetails[type]) === null || ref1 === void 0 ? void 0 : ref1.count) || count,
                    isSearchTab: true,
                    searchKeyword: searchKeyword,
                    onSearch: onSearch,
                    page: page,
                    type: type,
                    brand: brand,
                    searchDetails: searchDetails
                }),
                !isRendering && !forceTabLoader ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container kf-react-plp-container product-listing__tiles",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-listing__row d-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "filter-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: filterClass,
                                    "aria-modal": true,
                                    ref: filterModalWindow,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-listing__filter--sticky",
                                        "aria-hidden": !showFilter,
                                        onKeyDown: handleKeyPress,
                                        children: facets && /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter["default"], {
                                            rowCols: rowCols,
                                            texts: staticTexts,
                                            sort: sorts,
                                            selectedSort: selectedSort,
                                            onSortChange: onSort,
                                            currFilters: filterQueries,
                                            selectedFilterCount: filterQueries && filterQueries.reduce((acc, item)=>{
                                                return acc + item.value.length;
                                            }, 0),
                                            onFilter: handleFilter,
                                            close: setShowFilter,
                                            colors: colors,
                                            discontinuedCheck: false,
                                            displayShare: true,
                                            displayPrint: true,
                                            showFilter: showFilter,
                                            handleScroll: executeScroll,
                                            totalResults: total,
                                            showSort: width <= 1023,
                                            type: type,
                                            tabIndex: "0",
                                            hidePriceRange: true,
                                            page: page || "",
                                            facetData: facets,
                                            facetLabels: facetLabels,
                                            addToUrl: siteName !== null && siteName !== void 0 ? siteName : false,
                                            isLandscape: isLandscape
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: tileClass,
                                    children: [
                                        data.length === 0 ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-listing__row row-cols-1",
                                            role: "list",
                                            children: data.map((element, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-listing__tile",
                                                        role: "listitem",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                                            className: "lazyload-wrapper kf-lazyload-wrapper",
                                                            height: "300",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TechnicalTile/* default */.Z, {
                                                                page: page,
                                                                data: element,
                                                                fullWidth: !showFilter,
                                                                staticTexts: staticTexts,
                                                                highlightText: searchKeyword,
                                                                searchResultDataLayerObj: searchResultDataLayerObj
                                                            })
                                                        })
                                                    })
                                                }, i))
                                        }),
                                        data.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                            isSearchTab: true,
                                            staticTexts: staticTexts,
                                            displayShare: displayShare,
                                            displayPrint: displayPrint,
                                            curRows: curRows,
                                            productsPerPage: productsPerPage,
                                            totalResults: total,
                                            onRows: onRows,
                                            handleBackToTop: handleBackToTop,
                                            width: width,
                                            page: page,
                                            showSort: (0,helper/* shouldShowSortElement */._AA)(page),
                                            type: type,
                                            data: data,
                                            onLoadMore: onLoadMore
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_TabLoader, {})
            ]
        })
    });
};
/* harmony default export */ var v1_TechnicalTab = (TechnicalTab);
TechnicalTab.propTypes = {
    totalResults: (prop_types_default()).number,
    searchKeyword: (prop_types_default()).string,
    displayPrint: (prop_types_default()).any,
    displayShare: (prop_types_default()).any,
    page: (prop_types_default()).any,
    staticTexts: (prop_types_default()).object,
    onSearch: (prop_types_default()).func,
    productsPerPage: (prop_types_default()).any,
    type: (prop_types_default()).string,
    marketParamValues: (prop_types_default()).array,
    count: (prop_types_default()).number,
    brand: (prop_types_default()).string,
    isLandscape: (prop_types_default()).bool
};

// EXTERNAL MODULE: ./components/PartsViewer/v1/PartsViewer.jsx
var PartsViewer = __webpack_require__(17169);
// EXTERNAL MODULE: ./components/PartsViewer/v2/PartsViewer.jsx + 182 modules
var v2_PartsViewer = __webpack_require__(70159);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductTile/index.module.scss
var ProductTile_index_module = __webpack_require__(50702);
var ProductTile_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductTile_index_module);
// EXTERNAL MODULE: ./components/MyFavorites/v1/MyList/localization.js
var MyList_localization = __webpack_require__(57493);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/ProductCard/ProductCard.mjs + 18 modules
var ProductCard = __webpack_require__(3345);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/UIAnimations/Spinner/Spinner.mjs + 1 modules
var Spinner = __webpack_require__(3726);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Buttons/Button/Button.mjs + 2 modules
var Button = __webpack_require__(58510);
// EXTERNAL MODULE: ./responseProcessors/plpResponseProcessor.js
var plpResponseProcessor = __webpack_require__(86255);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/PlusIcon.mjs
var PlusIcon = __webpack_require__(35114);
// EXTERNAL MODULE: ./utils/product.js
var product = __webpack_require__(29843);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
;// CONCATENATED MODULE: ./responseProcessors/searchResponseProcessor/productTab.js







const pushToAdobeDataLayer = (eventInfo, productInfo)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = (getState === null || getState === void 0 ? void 0 : getState("page")) || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        ...productInfo ? {
            productInfo
        } : {},
        page
    });
};
// TODO: Will try to reuse plp price function later
const calculatePrice = (data, persona, currencySign, colorSku, isSterling, isCanada, isBundle)=>{
    // for sterling products, GST price list is used
    const finalPrice = (data === null || data === void 0 ? void 0 : data["priceList.".concat(persona, ".price_d")]) || 0;
    const discountedPrice = isSterling ? data === null || data === void 0 // Sterling (any country)
     ? void 0 : data["priceStartingAt.GST_d"] : isCanada ? data === null || data === void 0 // Non-Sterling + Canada
     ? void 0 : data["priceList.".concat(persona, ".price_d")] : data === null || data === void 0 // Non-Sterling + Non-Canada
     ? void 0 : data["priceList.".concat(persona, ".finalPrice_d")];
    const colorPriceList = (data === null || data === void 0 ? void 0 : data["Color.".concat(persona, ".Details_ss")]) || 0;
    const getPriceDetails = (gstDetails, colorSKU)=>{
        if (!Array.isArray(gstDetails)) return null;
        const match = gstDetails.find((item)=>item.startsWith(colorSKU + "|"));
        if (!match) return null;
        const parts = match.split("|");
        const displayPrice = parseFloat(parts[2]);
        const slashedPrice = parseFloat(parts[3]);
        return {
            displayPrice,
            slashedPrice
        };
    };
    // onHover color price logic
    if (colorSku !== data.sku_s && Array.isArray(colorPriceList)) {
        const colorPriceData = getPriceDetails(colorPriceList, colorSku);
        if (colorPriceData) {
            const { displayPrice , slashedPrice  } = colorPriceData;
            return {
                displayPrice: (0,plpResponseProcessor/* formatPrice */.T4)(displayPrice, currencySign),
                slashedPrice: slashedPrice && slashedPrice !== displayPrice ? (0,plpResponseProcessor/* formatPrice */.T4)(slashedPrice, currencySign) : null
            };
        }
    }
    if (isBundle && persona) {
        const bundlePriceKey = "priceStartingAt.".concat(persona, "_d");
        const bundlePrice = data === null || data === void 0 ? void 0 : data[bundlePriceKey];
        if (bundlePrice) {
            return {
                displayPrice: "Starting at ".concat(currencySign).concat(bundlePrice)
            };
        } else {
            // Fallback to min_price if persona-specific price is not available
            const fallbackPrice = data === null || data === void 0 ? void 0 : data["min_price"];
            if (fallbackPrice) {
                return {
                    displayPrice: "Starting at ".concat(currencySign).concat(fallbackPrice)
                };
            }
        }
    }
    // Normal price logic
    if (discountedPrice > 0 && discountedPrice !== finalPrice) {
        return {
            displayPrice: (0,plpResponseProcessor/* formatPrice */.T4)(discountedPrice, currencySign),
            slashedPrice: (0,plpResponseProcessor/* formatPrice */.T4)(finalPrice, currencySign)
        };
    } else {
        return {
            displayPrice: (0,plpResponseProcessor/* formatPrice */.T4)(discountedPrice, currencySign),
            slashedPrice: null
        };
    }
};
const handleCompare = (e, comparedProducts, category, data, setCompareErrorMessage, setCompareChecked, t)=>{
    // ✅ Don't update state immediately - validate first
    if (e.target.checked) {
        let variantFlag = false;
        if (comparedProducts.length < 4) {
            const allVariantSkus = comparedProducts === null || comparedProducts === void 0 ? void 0 : comparedProducts.map((a)=>{
                const variantSkus = a["variantList.sku_ss"] || [];
                return [
                    ...variantSkus,
                    a.masterSKU_s || a.sku_s
                ].filter(Boolean);
            }).flat();
            if (allVariantSkus === null || allVariantSkus === void 0 ? void 0 : allVariantSkus.includes(data.sku_s)) {
                variantFlag = true;
            }
            if (category !== "" && category !== data.Product_Category) {
                setCompareErrorMessage(t("kf.compare.validation.sameCategory"));
                setCompareChecked(false) // ✅ Only set false on validation failure
                ;
                (0,product/* removeFromCompareProduct */.Zj)(data.sku_s);
            } else {
                (0,product/* addToCompareProduct */.dX)(data.sku_s, data);
                setCompareChecked(true) // ✅ Only set true when validation passes
                ;
            }
        } else if (variantFlag && "compare_products_v1" === "compare_products_v2") {} else {
            setCompareErrorMessage(t("kf.plp.error.maxProduct"));
            setCompareChecked(false) // ✅ Set false when max products reached
            ;
            (0,product/* removeFromCompareProduct */.Zj)(data.sku_s);
        }
    } else {
        setCompareChecked(false) // ✅ Set false when unchecking
        ;
        (0,product/* removeFromCompareProduct */.Zj)(data.sku_s);
    }
};
const compareColorData = (gstDetails, skuDetails, isSterling)=>{
    // Step 1: Extract SKUs from Color.GST.Details_ss
    const gstSKUs = new Set(gstDetails.map((item)=>item.split("|")[0]));
    // Step 2: Filter Color.SKU.Details_ss entries where SKU is in GST list
    const matched = skuDetails.filter((item)=>{
        const sku = item.split("|")[2];
        return gstSKUs.has(sku);
    });
    const uniqueColors = [];
    const seenColors = new Set();
    for (const item of matched){
        const colorName = item.split("|")[0];
        if (!seenColors.has(colorName)) {
            seenColors.add(colorName);
            uniqueColors.push(item);
        }
    }
    // Step 3: Return the matched entries
    return !isSterling ? uniqueColors : skuDetails;
};
const getProductInfo = (param)=>{
    let { product , isSterling , siteName , colorSku , skuPrepend , cartData , locale , type , isCanada  } = param;
    const { productCouponCode , productCoupondiscount  } = (0,helper/* getCurrentSkuCouponDiscounts */.mPk)({
        cart: cartData,
        sku: product.sku_s,
        locale: locale
    });
    const getGlobalPromotionPrice = (price, discountPercent)=>{
        const discountAmount = Number((price - discountPercent).toFixed(2));
        // If there is a discount, return the price minus the discount amount (rounded to 2 decimals)
        if (discountPercent && discountAmount) {
            return Number((price - discountAmount).toFixed(2));
        }
        // Otherwise, return the regular price
        return price;
    };
    const getDiscountPriceState = (badgeVal, isDiscountedPrice, discountPercent)=>{
        return badgeVal && isDiscountedPrice ? "percentOff|" + discountPercent : "regular price";
    };
    const getColorName = (color, colorSku)=>{
        var ref;
        var ref1;
        return (ref1 = (ref = color.find((item)=>item.split("|")[2] === colorSku)) === null || ref === void 0 ? void 0 : ref.split("|")[0]) !== null && ref1 !== void 0 ? ref1 : "";
    };
    const getDefaultImage = ()=>{
        var ref, ref1;
        return !isSterling ? (ref1 = product === null || product === void 0 ? void 0 : (ref = product["productImages.labelWithUrl_ss"]) === null || ref === void 0 ? void 0 : ref.find((img)=>product.sku_s === img.split("|")[0])) === null || ref1 === void 0 ? void 0 : ref1.split("|")[1] : "MissingImage";
    };
    const getProductSalePrice = ()=>{
        var ref, ref1;
        return !isSterling ? (ref1 = product === null || product === void 0 ? void 0 : (ref = product.variantPrice) === null || ref === void 0 ? void 0 : ref.find((img)=>colorSku === img.split("|")[0])) === null || ref1 === void 0 ? void 0 : ref1.split("|")[3] : product === null || product === void 0 ? void 0 : product.discountedPrice;
    };
    const getProductInStock = (color, colorSku)=>{
        var ref;
        return ((ref = color.find((item)=>item.split("|")[2] === colorSku)) === null || ref === void 0 ? void 0 : ref.split("|")[3]) === "true" ? constants.STOCKS.IN_STOCK : constants.STOCKS.OUT_OF_STOCK;
    };
    var ref;
    // Product Info Object
    const productInfo = {
        productBrand: isSterling ? constants.BRAND_NAME.sterling.toLowerCase() : (0,helper/* sanitizeTextForAnalytics */.T68)(siteName === null || siteName === void 0 ? void 0 : siteName.toLowerCase()),
        description: (0,helper/* sanitizeTextForAnalytics */.T68)((type === null || type === void 0 ? void 0 : type.toLowerCase()) === "parts" ? product === null || product === void 0 ? void 0 : product.productName_s : isSterling && isCanada ? product === null || product === void 0 ? void 0 : product.ProductDescriptionProduct_s : product === null || product === void 0 ? void 0 : product.ProductDescriptionProductShort_s) || "n/a",
        globalPromotionPrice: getGlobalPromotionPrice(product.price, product.discountPercent),
        priceState: getDiscountPriceState(product.badgeValue, product.isDiscountedPrice, product.discountPercent),
        productBasePrice: Number(product === null || product === void 0 ? void 0 : product.price),
        productCategory: (0,helper/* sanitizeTextForAnalytics */.T68)(product === null || product === void 0 ? void 0 : product.category) || "n/a",
        productColor: (0,helper/* sanitizeTextForAnalytics */.T68)(getColorName(product.colors, colorSku)) || "n/a",
        productID: skuPrepend + colorSku,
        productName: (0,helper/* sanitizeTextForAnalytics */.T68)(isSterling ? product.ProductBrandName_s : (type === null || type === void 0 ? void 0 : type.toLowerCase()) === "parts" ? product.productName_s : product.RegionBrandName_s || product.ProductBrandName_s) || "n/a",
        productRoom: (0,helper/* sanitizeTextForAnalytics */.T68)((product === null || product === void 0 ? void 0 : product["category1_s"]) === "n/a" ? product === null || product === void 0 ? void 0 : product.category : product === null || product === void 0 ? void 0 : product["category1_s"]),
        productSalePrice: Number(getProductSalePrice()) || 0,
        productSaleable: !product.colors.length ? false : true,
        productStatus: getProductInStock(product.colors, colorSku) || "n/a",
        productSuperSku: product.isSuperSKU,
        productTileName: (0,helper/* sanitizeTextForAnalytics */.T68)(product.Tile_Title) || "n/a",
        defaultImageName: getDefaultImage() || "MissingImage",
        productCollectionsName: (0,helper/* sanitizeTextForAnalytics */.T68)(product.category || (product === null || product === void 0 ? void 0 : product["ProductBrandNameDisplay_s"])),
        globalOffer: product.badgeValue ? product.badgeValue : "n/a",
        globalDiscount: product.discountPercent ? product.discountAmount : 0,
        productPartnerBuyNow: (ref = product === null || product === void 0 ? void 0 : product["ProductIsRetail"]) !== null && ref !== void 0 ? ref : false,
        pdpType: (product === null || product === void 0 ? void 0 : product.primaryBundleSKU_s) ? constants.BUNDLE_LABEL.toLowerCase() : "regular finished goods & service parts",
        productFindingMethod: "n/a",
        productCouponCode: productCouponCode.join("|") || "n/a",
        productCoupondiscount: productCoupondiscount,
        frequency: "n/a",
        isRecommended: "n/a",
        isSendNow: "n/a",
        isSubscription: "n/a",
        quantity: "n/a",
        ratings: "n/a",
        numberOfReviews: "n/a"
    };
    return productInfo;
};
const getEventInfo = (param)=>{
    let { isSterling , product , index , pdpURL , searchResultDataLayerObj , clickEvent , compareChecked , favIconState  } = param;
    let alterNameType = "";
    let compareInternalLinkName = "";
    let compareLinkType = "";
    let compareZoneName = "";
    if (clickEvent === "compare_click") {
        alterNameType = compareChecked ? "compare remove" : "compare add";
        compareInternalLinkName = compareChecked ? "remove compare" : "add to compare";
        compareLinkType = "compare";
        compareZoneName = "compare";
    } else if (clickEvent === "favorites") {
        if (favIconState) {
            alterNameType = "favorite remove";
        } else {
            alterNameType = "favorite add";
        }
    } else if (clickEvent === "service_parts_click") {
        alterNameType = "parts diagram";
        compareZoneName = "parts diagram";
        compareLinkType = "parts diagram";
    } else if (clickEvent === "quick_view_click") {
        compareZoneName = "".concat(constants.QUICK_VIEW);
        compareLinkType = "".concat(constants.QUICK_VIEW);
    } else if (clickEvent === "quick_view_close") {
        compareZoneName = "".concat(constants.QUICK_VIEW, ":close");
        compareLinkType = "".concat(constants.QUICK_VIEW, ":close");
    } else {
        alterNameType = "navigation";
        compareLinkType = "product tiles";
        compareZoneName = "products";
    }
    const productName = isSterling ? product.ProductBrandName_s : product.RegionBrandName_s || product.ProductBrandName_s;
    const eventInfo = {
        eventAction: clickEvent === "quick_view_click" ? "search results:".concat(constants.QUICK_VIEW) : clickEvent === "quick_view_close" ? "search results:quick view modal:close" : "search results product ".concat(alterNameType),
        eventName: clickEvent === "quick_view_click" ? "search results:".concat(constants.QUICK_VIEW) : clickEvent === "quick_view_close" ? "search results:quick view modal:close" : "search results product ".concat(alterNameType),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        productGridPosition: index + 1,
        internalLinkName: isSterling ? constants.SEARCH_INTERNAL_TYPE.sterlingResults : clickEvent === "swatch_click" ? "color selection" : clickEvent === "compare_click" ? compareInternalLinkName : clickEvent === "service_parts_click" ? "service parts" : clickEvent === "quick_view_click" ? "".concat(constants.QUICK_VIEW) : clickEvent === "quick_view_close" ? "close" : (0,helper/* sanitizeTextForAnalytics */.T68)(productName),
        internalLinkPosition: "search results",
        internalLinkType: "search results:".concat(compareLinkType),
        internalLinkZoneName: "search results:".concat(compareZoneName, ":main content area"),
        internalLinkURL: isSterling ? window.location.href : clickEvent === "compare_click" ? "n/a" : clickEvent === "service_parts_click" ? "n/a" : clickEvent === "quick_view_click" ? "n/a" : clickEvent === "quick_view_close" ? "n/a" : window.location.origin + pdpURL(product.sku_s),
        clickInternalLinks: "true",
        ...clickEvent !== "favorites" && clickEvent !== "service_parts_click" && clickEvent !== "quick_view_click" && clickEvent !== "quick_view_close" ? (0,helper/* getSearchDataLayerDetails */.g1g)(searchResultDataLayerObj) : {},
        ...(clickEvent === "quick_view_click" || clickEvent === "quick_view_close") && {
            modalName: constants.QUICK_VIEW_MODAL
        }
    };
    return eventInfo;
};
// Main function to get Product Tab Data
const getProductTabData = (param)=>{
    let { data , isSterling , globalConfig , persona , handleOnClickPartsDiagramLink , compareData , compareErrorMessage , setCompareErrorMessage , compareChecked , setCompareChecked , favIconState , handleFavorite , swatchCount , setColorSku , colorSku , index , cartData , locale , searchResultDataLayerObj , brandSwitcherItems , type , width , paginationState , setCardLoader , setShowQuickViewModal , setScrollY , t , saveButtonRef , handleSaveButtonFocus  } = param;
    var ref, ref1, ref2, ref3, ref4;
    var _curRows, _start;
    const currentRows = Number((_curRows = paginationState.curRows) !== null && _curRows !== void 0 ? _curRows : 0) + Number((_start = paginationState.start) !== null && _start !== void 0 ? _start : 0);
    const { comparedProducts , category  } = compareData;
    const { general: { swatchUrl ="" , disableCommerce , siteName  } = {} , presetConfigs: { plp: plpPresetConfig  } = {} , plpConfigurations: { myArrayList: plpBadgeList = []  } = {} , internationalization: { currencySign  } = {} , apiEndpoints: { skuPrepend =""  } = {} , general ={} , plpServletPath ={}  } = globalConfig;
    var ref5, ref6, ref7, ref8, ref9, ref10;
    const product = {
        ...data,
        shipmentDate: (ref5 = data === null || data === void 0 ? void 0 : data["RegionReleaseforShipment_dt"]) !== null && ref5 !== void 0 ? ref5 : "",
        badgeValue: (ref6 = data === null || data === void 0 ? void 0 : data["priceList.".concat(persona, ".saleOffer_s")]) !== null && ref6 !== void 0 ? ref6 : "",
        price: (ref7 = data === null || data === void 0 ? void 0 : data["priceStartingAt.".concat(persona, "_d")]) !== null && ref7 !== void 0 ? ref7 : 0,
        discountedPrice: (ref8 = data === null || data === void 0 ? void 0 : data["priceList.".concat(persona, ".finalPrice_d")]) !== null && ref8 !== void 0 ? ref8 : 0,
        isDiscountedPrice: data === null || data === void 0 ? void 0 : data["priceList.".concat(persona, ".discountedPrice_d")],
        discountPercent: (data === null || data === void 0 ? void 0 : data["priceList.".concat(persona, ".saleOffer_s")]) && (data === null || data === void 0 ? void 0 : data["priceList.".concat(persona, ".discountedPrice_d")]) ? 100 - Math.round((data === null || data === void 0 ? void 0 : data["priceList.".concat(persona, ".discountedPrice_d")]) / (data === null || data === void 0 ? void 0 : data["priceStartingAt.".concat(persona, "_d")]) * 100) : 0,
        resourceNvznId: data === null || data === void 0 ? void 0 : data["ResourceNvznId_s"],
        resourceVntanaProductId: data === null || data === void 0 ? void 0 : data["ResourceVntanaProductId_s"],
        resourceVntanaProductIdList: data === null || data === void 0 ? void 0 : data["ResourceVntanaProductIdList_ss"],
        resourceNvznIdList: data === null || data === void 0 ? void 0 : data["ResourceNvznIdList_ss"],
        category: (ref10 = (ref9 = data === null || data === void 0 ? void 0 : data["Product_Category"]) !== null && ref9 !== void 0 ? ref9 : data === null || data === void 0 ? void 0 : data["ProductLocalCategory_s"]) !== null && ref10 !== void 0 ? ref10 : "",
        slug: data === null || data === void 0 ? void 0 : data["slug_s"],
        sku: data === null || data === void 0 ? void 0 : data["sku_s"],
        variantPrice: data === null || data === void 0 ? void 0 : data["Color.".concat(persona, ".Details_ss")],
        colors: compareColorData((data === null || data === void 0 ? void 0 : data["Color.".concat(persona, ".Details_ss")]) || [], (data === null || data === void 0 ? void 0 : data["Color.SKU.Details_ss"]) || [], isSterling),
        isSuperSKU: (data === null || data === void 0 ? void 0 : data["comboSKUAvailable_b"]) || false,
        isBundleProduct: Boolean(data === null || data === void 0 ? void 0 : data.primaryBundleSKU_s)
    };
    const bundleFlag = data === null || data === void 0 ? void 0 : data.Bundle_s;
    const isBundle = bundleFlag === "Yes";
    const configdata = {
        plpBadgeList,
        disableCommerce
    };
    const badgesdata = (0,plpResponseProcessor/* getBadgesData */.u2)(product, configdata) || [];
    const isCanada = (0,helper/* isCanadaSite */.guj)(siteName);
    const { displayPrice , slashedPrice  } = calculatePrice(data, persona, currencySign, colorSku, isSterling, isCanada, isBundle);
    const skuForBundle = isBundle && (data === null || data === void 0 ? void 0 : (ref = data["variantList.sku_ss"]) === null || ref === void 0 ? void 0 : ref[0]) ? data === null || data === void 0 ? void 0 : (ref1 = data["variantList.sku_ss"]) === null || ref1 === void 0 ? void 0 : ref1[0] : "";
    const pdpURL = (pSku)=>{
        const skuToUse = isBundle ? skuForBundle || pSku : pSku;
        return "".concat((0,helper/* getPDPUrlWithConfig */.Upy)(product.category, product.slug, plpServletPath, general), "?skuId=").concat(skuToUse);
    };
    const productInfo = getProductInfo({
        product,
        isSterling,
        siteName,
        colorSku,
        skuPrepend,
        cartData,
        locale,
        type,
        isCanada
    });
    const getAnalyticsInfoOnclick = function() {
        let eventType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", status = arguments.length > 1 ? arguments[1] : void 0, message = arguments.length > 2 ? arguments[2] : void 0;
        const eventInfo = getEventInfo({
            isSterling,
            product,
            index,
            pdpURL,
            searchResultDataLayerObj,
            clickEvent: eventType,
            compareChecked,
            favIconState
        });
        eventInfo.eventStatus = status || "n/a";
        eventInfo.eventMsg = (0,helper/* sanitizeTextForAnalytics */.T68)(message) || "n/a";
        pushToAdobeDataLayer(eventInfo, productInfo);
    };
    const setSessionStorageForPLP = (pSku)=>{
        sessionStorage.setItem("plpScrollSku", "K-" + pSku) // back=K-T13140-4A-CP
        ;
        sessionStorage.setItem("plpCurrentRows", currentRows);
        setCardLoader(true);
    };
    const allColorsData = (0,plpResponseProcessor/* colorFetcheslogic */.Ev)(product, width, swatchUrl);
    const colorsData = allColorsData.slice(0, swatchCount) || [];
    const colorsDataWithEvent = colorsData.map((color)=>({
            ...color,
            ...!isSterling && {
                component: "a",
                href: pdpURL(color.sku)
            },
            onMouseEnter: ()=>{
                setColorSku(color.sku);
            },
            onMouseLeave: ()=>{
                setColorSku(data.sku_s);
            }
        }));
    // quick view modal open
    const handleQuickViewCTAClick = (e, sku)=>{
        const scrollY = window === null || window === void 0 ? void 0 : window.scrollY;
        setScrollY(scrollY);
        setShowQuickViewModal(true);
        sessionStorage.setItem("plpScrollSku", "K-" + sku) // back=K-T13140-4A-CP
        ;
        sessionStorage.setItem("plpCurrentRows", currentRows);
    };
    const variantImages = !isSterling && ((ref3 = data === null || data === void 0 ? void 0 : (ref2 = data["productImages.labelWithUrl_ss"]) === null || ref2 === void 0 ? void 0 : ref2.find((img)=>colorSku === img.split("|")[0])) === null || ref3 === void 0 ? void 0 : ref3.split("|")[1]);
    const getBundleImageUrl = ()=>{
        var ref, ref1;
        // Step 1: If we have a direct bundleImageUrl, return it directly
        if (data === null || data === void 0 ? void 0 : data["BundlePLPImageURL_s"]) {
            return data === null || data === void 0 ? void 0 : data["BundlePLPImageURL_s"];
        }
        // Step 2: If we have variantImages, use getPresetUrl with it
        if (variantImages) {
            return (0,utils/* getPresetUrl */.v$)(width, width <= 1024 ? 2 : 3, swatchUrl, variantImages, plpPresetConfig, false);
        }
        // Step 3: Find the bundle image URL and use getPresetUrl
        const bundleImageUrl = (ref1 = data === null || data === void 0 ? void 0 : (ref = data["productImages.labelWithUrl_ss"]) === null || ref === void 0 ? void 0 : ref.find((img)=>skuForBundle === img.split("|")[0])) === null || ref1 === void 0 ? void 0 : ref1.split("|")[1];
        return (0,utils/* getPresetUrl */.v$)(width, width <= 1024 ? 2 : 3, swatchUrl, bundleImageUrl, plpPresetConfig, false);
    };
    // Main props to be returned - Product Card props
    const props = {
        type: "Product Card",
        mod: "white",
        id: "".concat(data.sku_s),
        key: "".concat(skuPrepend).concat(data.sku_s),
        ...!isSterling && width > 1023 && (data === null || data === void 0 ? void 0 : data["productDiscontinued_b"]) !== true && !isCanada && !(data === null || data === void 0 ? void 0 : (ref4 = data.sku_s) === null || ref4 === void 0 ? void 0 : ref4.includes("BNDL")) && (data === null || data === void 0 ? void 0 : data["ProductIsRetail_s"]) !== "true" && (data === null || data === void 0 ? void 0 : data["SKUIsProjectPack_s"]) !== "Yes" && {
            quickViewCTA: {
                label: t("kf.plp.product.quick.view.label"),
                "aria-label": "Open Quick View for ".concat(data === null || data === void 0 ? void 0 : data.ProductBrandName_s),
                icon: PlusIcon/* PlusIcon */.p,
                onClick: (e)=>{
                    handleQuickViewCTAClick(e, data === null || data === void 0 ? void 0 : data.sku_s);
                    getAnalyticsInfoOnclick("quick_view_click");
                }
            }
        },
        ...!isSterling && {
            href: pdpURL(data.sku_s)
        },
        image: {
            id: "".concat(variantImages + "_IMG_" + index),
            reveal: "default",
            loading: "blank",
            src: isSterling ? data === null || data === void 0 ? void 0 : data["productImage.url_ss"][0] : isBundle ? getBundleImageUrl() : (0,utils/* getPresetUrl */.v$)(width, width <= 1024 ? 2 : 3, swatchUrl, variantImages, plpPresetConfig, false),
            alt: data.metaTitle_s,
            onError: (e)=>{
                e.currentTarget.onerror = null;
                e.currentTarget.src = image_missing/* default.src */.Z.src;
            },
            ...!isSterling ? {
                onClick: ()=>{
                    getAnalyticsInfoOnclick();
                    setSessionStorageForPLP(data.sku_s);
                }
            } : {
                onClick: ()=>{
                    (0,utils/* handleViewSterlingResults */.Vw)(!isCanada ? brandSwitcherItems : constants.STERLING_LINK, data === null || data === void 0 ? void 0 : data.Brand_ss[0], data.sku_s);
                    getAnalyticsInfoOnclick("sterling_view_results");
                }
            }
        },
        description: {
            text: isBundle ? data === null || data === void 0 ? void 0 : data.Collapse_Description_s : isSterling && isCanada ? product === null || product === void 0 ? void 0 : product.ProductDescriptionProduct_s : data.ProductDescriptionProductShort_s,
            "aria-label": data.ProductDescriptionProductShort_s,
            ...!isSterling ? {
                component: "a",
                href: pdpURL(data.sku_s),
                onClick: ()=>{
                    getAnalyticsInfoOnclick();
                    setSessionStorageForPLP(data.sku_s);
                }
            } : {
                onClick: ()=>{
                    (0,utils/* handleViewSterlingResults */.Vw)(!isCanada ? brandSwitcherItems : constants.STERLING_LINK, data === null || data === void 0 ? void 0 : data.Brand_ss[0], data.sku_s);
                    getAnalyticsInfoOnclick("sterling_view_results");
                }
            }
        },
        title: {
            text: isBundle ? data === null || data === void 0 ? void 0 : data.Collapse_Title_s : isSterling ? data.ProductBrandName_s : (type === null || type === void 0 ? void 0 : type.toLowerCase()) === "parts" ? data.productName_s : data.RegionBrandName_s || data.productName_s,
            "aria-label": isSterling ? data.ProductBrandName_s : data.RegionBrandName_s || data.ProductBrandName_s,
            ...!isSterling ? {
                component: "a",
                href: pdpURL(data.sku_s),
                onClick: ()=>{
                    getAnalyticsInfoOnclick();
                    setSessionStorageForPLP(data.sku_s);
                }
            } : {
                onClick: ()=>{
                    (0,utils/* handleViewSterlingResults */.Vw)(!isCanada ? brandSwitcherItems : constants.STERLING_LINK, data === null || data === void 0 ? void 0 : data.Brand_ss[0], data.sku_s);
                    getAnalyticsInfoOnclick("sterling_view_results");
                }
            }
        },
        price: {
            text: displayPrice,
            "aria-label": "".concat(t("kf.plp.label.salePriceAria"), " ").concat(displayPrice !== null && displayPrice !== void 0 ? displayPrice : 0),
            ...!isSterling ? {
                component: "a",
                href: pdpURL(data.sku_s),
                onClick: ()=>{
                    getAnalyticsInfoOnclick();
                    setSessionStorageForPLP(data.sku_s);
                }
            } : {
                onClick: ()=>{
                    (0,utils/* handleViewSterlingResults */.Vw)(!isCanada ? brandSwitcherItems : constants.STERLING_LINK, data === null || data === void 0 ? void 0 : data.Brand_ss[0], data.sku_s);
                    getAnalyticsInfoOnclick("sterling_view_results");
                }
            }
        },
        slashedPrice: {
            text: slashedPrice,
            "aria-label": "".concat(t("kf.plp.label.originalPriceAria"), " ").concat(slashedPrice !== null && slashedPrice !== void 0 ? slashedPrice : 0),
            ...!isSterling && {
                component: "a",
                href: pdpURL(data.sku_s),
                onClick: ()=>{
                    getAnalyticsInfoOnclick();
                    setSessionStorageForPLP(data.sku_s);
                }
            }
        },
        ...!isSterling && !isBundle && product.category !== "Install Services" && {
            isSaved: favIconState,
            saveCTA: {
                ref: saveButtonRef,
                onFocus: handleSaveButtonFocus,
                "aria-label": "Add ".concat(data.ProductBrandName_s, " to list"),
                onClick: (e)=>{
                    handleFavorite(e, data.sku_s, productInfo, getAnalyticsInfoOnclick);
                }
            }
        },
        productDetails: {
            SKU: {
                text: isBundle ? skuForBundle : skuPrepend + colorSku,
                ...!isSterling ? {
                    component: "a",
                    href: pdpURL(data.sku_s),
                    onClick: ()=>{
                        getAnalyticsInfoOnclick();
                        setSessionStorageForPLP(data.sku_s);
                    }
                } : {
                    onClick: ()=>{
                        (0,utils/* handleViewSterlingResults */.Vw)(!isCanada ? brandSwitcherItems : constants.STERLING_LINK, data === null || data === void 0 ? void 0 : data.Brand_ss[0], data.sku_s);
                        getAnalyticsInfoOnclick("sterling_view_results");
                    }
                }
            },
            tags: badgesdata,
            ...!isBundle && {
                additionalLink: {
                    "aria-label": "See Service Parts for ".concat(data.ProductBrandName_s),
                    text: (data === null || data === void 0 ? void 0 : data["ProductProductNo_s"]) && (data === null || data === void 0 ? void 0 : data["ProductResource.InteractiveSVG.resourceName_ss"]) ? t("kf.search.serviceparts") : "",
                    onClick: ()=>{
                        handleOnClickPartsDiagramLink(product);
                        getAnalyticsInfoOnclick("service_parts_click");
                    }
                }
            },
            ...!isSterling && !isBundle && !(data === null || data === void 0 ? void 0 : data.primaryBundleSKU_s) && product.category !== "Install Services" && width > 1023 && {
                checkbox: {
                    label: t("kf.compare.label.compare"),
                    "aria-label": "Add ".concat(data.ProductBrandName_s, " to compare rack."),
                    checked: compareChecked,
                    onChange: (e)=>{
                        handleCompare(e, comparedProducts, category, data, setCompareErrorMessage, setCompareChecked, t);
                        getAnalyticsInfoOnclick("compare_click");
                    },
                    ...compareErrorMessage && {
                        tooltip: {
                            label: compareErrorMessage,
                            width: "200px"
                        }
                    }
                }
            },
            ...!isBundle && {
                colorSwatches: {
                    "aria-label": "".concat(colorsDataWithEvent.length).concat(t("kf.plp.label.colorsLinkAria")),
                    colors: colorsDataWithEvent,
                    extraColors: allColorsData.length > swatchCount ? allColorsData.length - swatchCount : "",
                    ...colorSku !== data.sku_s && {
                        selectedColor: colorSku
                    },
                    ...!isSterling ? {
                        onColorSelected: ()=>{
                            getAnalyticsInfoOnclick("swatch_click");
                            setSessionStorageForPLP(data.sku_s);
                        }
                    } : {
                        onClick: ()=>{
                            (0,utils/* handleViewSterlingResults */.Vw)(!isCanada ? brandSwitcherItems : constants.STERLING_LINK, data === null || data === void 0 ? void 0 : data.Brand_ss[0], colorSku);
                            getAnalyticsInfoOnclick("sterling_view_results");
                        }
                    }
                }
            }
        },
        height: "100%"
    };
    const sterlingButtonProps = {
        mod: "white",
        children: t("kf.viewSterlingResults"),
        variant: "primary",
        size: "small",
        fullWidth: true,
        disabled: false,
        onClick: ()=>{
            (0,utils/* handleViewSterlingResults */.Vw)(!isCanada ? brandSwitcherItems : constants.STERLING_LINK, data === null || data === void 0 ? void 0 : data.Brand_ss[0], data.sku_s);
            getAnalyticsInfoOnclick("sterling_view_results");
        }
    };
    return {
        productTabProps: props,
        sterlingButtonProps,
        getAnalyticsInfoOnclick
    };
};

// EXTERNAL MODULE: ./hooks/useProductFavorites.js
var useProductFavorites = __webpack_require__(69663);
// EXTERNAL MODULE: ./components/SaveToList/index.jsx
var SaveToList = __webpack_require__(4165);
// EXTERNAL MODULE: ./components/ListConfirmationModal/index.jsx + 1 modules
var ListConfirmationModal = __webpack_require__(63652);
// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
// EXTERNAL MODULE: ./store/features/favoritesSlice.js + 1 modules
var favoritesSlice = __webpack_require__(7737);
// EXTERNAL MODULE: ./components/SaveToList/analytics.js
var analytics = __webpack_require__(65258);
// EXTERNAL MODULE: ./components/SaveToList/constant.js
var constant = __webpack_require__(4943);
// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 1 modules
var Modal = __webpack_require__(78145);
;// CONCATENATED MODULE: ./components/Shared/ProductList/v2/ProductTile/V2/ProductTileHOC.jsx






















const QuickView = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(2374), __webpack_require__.e(5490)]).then(__webpack_require__.bind(__webpack_require__, 10322)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10322)
            ]
    }
});
const productTileHoc = (WrappedComponent)=>{
    return function WithProductCardWrapper(param) {
        let { data , isSterling , handleOnClickPartsDiagramLink , swatchCount , index , searchResultDataLayerObj , brandSwitcherItems , type , paginationState , quickViewAuthData  } = param;
        const persona = (0,helper/* getUserPersona */.shu)();
        const router = (0,next_router.useRouter)();
        const [width] = (0,useWindowResize/* default */.Z)();
        const locale = router.locale;
        const dispatch = (0,es/* useDispatch */.I0)();
        const { t  } = (0,esm/* useTranslation */.$G)();
        const { globalConfig ={} , featureFlags ={} , toaster  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
        const stableSwatchCount = (0,react.useMemo)(()=>swatchCount, [
            swatchCount
        ]);
        const { MYSQLCONNSTR_ENABLE_SHOPPING_LISTS_V2: isSaveProductToList = false  } = featureFlags;
        const compareData = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
        const { userListItemsSkus ={}  } = (0,es/* useSelector */.v9)(favoritesSlice/* selectFavoritesState */.Qx);
        const favorites = (0,es/* useSelector */.v9)((state)=>{
            var ref;
            return ((ref = state.favorites.favorites) === null || ref === void 0 ? void 0 : ref.lineItems) || [];
        }, (prev, next)=>JSON.stringify(prev) === JSON.stringify(next));
        const cartData = (0,es/* useSelector */.v9)((state)=>state.cart.data);
        const { getFavIconStatus  } = (0,useProductFavorites/* default */.Z)();
        const { isAuth: isAuthenticated  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
        const [mainProps, setMainProps] = (0,react.useState)({});
        const [compareErrorMessage, setCompareErrorMessage] = (0,react.useState)("");
        const [compareChecked, setCompareChecked] = (0,react.useState)(false);
        const [productSavedToList, setProductSavedToList] = (0,react.useState)(false);
        const [openModal, setOpenModal] = (0,react.useState)(false);
        const [deleteFromList, setDeleteFromList] = (0,react.useState)(false);
        const [showAddToList, setShowAddToList] = (0,react.useState)(false);
        const [loginFavouriteCallback, setLoginFavouriteCallback] = (0,react.useState)(null);
        const [toasterContent, setToasterContent] = (0,react.useState)({
            successMessage: "",
            unfavoriteSuccessMessage: ""
        });
        const [favIconState, setFavIconState] = (0,react.useState)(false);
        const [isFavorite, setIsFavorite] = (0,react.useState)(false);
        const [colorSku, setColorSku] = (0,react.useState)(data.sku_s);
        const [cardLoader, setCardLoader] = (0,react.useState)(false);
        const [showQuickViewModal, setShowQuickViewModal] = (0,react.useState)(false);
        const [scrollY, setScrollY] = (0,react.useState)(0);
        const saveButtonRef = (0,react.useRef)(null);
        (0,react.useEffect)(()=>{
            setToasterMessage();
            setIsFavorite((favorites === null || favorites === void 0 ? void 0 : favorites.find((vl)=>vl.productId === data["ctId_s"])) ? true : false);
        }, []);
        (0,react.useEffect)(()=>{
            if (false) {}
            const clearPlpLoader = ()=>{
                setCardLoader(false);
            };
            const onPageShow = (e)=>{
                if (e && e.persisted) {
                    clearPlpLoader();
                } else {
                    const overlay = document.querySelector(".spinner-overlay");
                    if (overlay) clearPlpLoader();
                }
            };
            const onVisibility = ()=>{
                if (document.visibilityState === "visible") {
                    const overlay = document.querySelector(".spinner-overlay");
                    if (overlay) clearPlpLoader();
                }
            };
            const onPopState = ()=>{
                const overlay = document.querySelector(".spinner-overlay");
                if (overlay) clearPlpLoader();
            };
            window.addEventListener("pageshow", onPageShow);
            document.addEventListener("visibilitychange", onVisibility);
            window.addEventListener("popstate", onPopState);
            return ()=>{
                window.removeEventListener("pageshow", onPageShow);
                document.removeEventListener("visibilitychange", onVisibility);
                window.removeEventListener("popstate", onPopState);
            };
        }, []);
        const setToasterMessage = async ()=>{
            if (!isEmpty_default()(toaster === null || toaster === void 0 ? void 0 : toaster.content)) {
                const { successMessage , unfavoriteSuccessMessage  } = toaster.content;
                setToasterContent({
                    successMessage: await (0,helper/* getShortenedUrl */.Ppy)(successMessage),
                    unfavoriteSuccessMessage: await (0,helper/* getShortenedUrl */.Ppy)(unfavoriteSuccessMessage)
                });
            }
        };
        const handleSaveToListSuccessCallBack = ()=>{
            setProductSavedToList(true);
        };
        // Modified: Store both event and sku in loginFavouriteCallback, add isPostLoginRetry flag
        const handleLogin = function(e, setLoginFavouriteCallback, dispatch, setAuthModalVisibility, sku, productInfo) {
            let isPostLoginRetry = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
            e.preventDefault();
            e.stopPropagation();
            if (!isPostLoginRetry) {
                (0,analytics/* dataLayerSavetolistGuest */.OR)(productInfo);
            }
            setLoginFavouriteCallback({
                event: e,
                sku,
                isPostLoginRetry
            });
            dispatch(setAuthModalVisibility({
                show: true
            }));
        };
        // Modified: Accepts either (e, sku) or ({event, sku, isPostLoginRetry})
        const handleFavorite = (eOrObj, skuArg, productInfo, getAnalyticsInfoOnclick)=>{
            let e;
            let sku;
            let isPostLoginRetry = false;
            if (eOrObj && typeof eOrObj === "object" && "event" in eOrObj && "sku" in eOrObj) {
                e = eOrObj.event;
                sku = eOrObj.sku;
                isPostLoginRetry = !!eOrObj.isPostLoginRetry;
            } else {
                e = eOrObj;
                sku = skuArg;
            }
            if (!e || !sku) return;
            window.preActiveElement = e.target;
            if (isAuthenticated) {
                if (isSaveProductToList) {
                    if (userListItemsSkus[sku]) {
                        setOpenModal(true);
                        setDeleteFromList(true);
                        (0,analytics/* dataLayerHeartClickSaveListButton */.y3)(productInfo, "delete from list", constant/* WISHLIST_DELETE */.Ik);
                        return;
                    }
                    setShowAddToList(true);
                    setLoginFavouriteCallback(null);
                    // Only fire analytics for guest, not for logged-in user after login
                    if (!isPostLoginRetry) {
                        (0,analytics/* dataLayerHeartClickSaveListButton */.y3)(productInfo, "save to list", constant/* WISHLIST_SAVE */.O1);
                    }
                    return;
                }
            } else {
                // Only fire guest analytics on initial click, not on post-login retry
                handleLogin(e, setLoginFavouriteCallback, dispatch, authSlice/* setAuthModalVisibility */.LY, sku, productInfo, false // always false here, initial guest click
                );
                return;
            }
            if (isFavorite === true) {
                favorites === null || favorites === void 0 ? void 0 : favorites.map((fav)=>{
                    if (fav.productId === data["ctId_s"]) {
                        if (!isAuthenticated) {
                            handleLogin(e, setLoginFavouriteCallback, dispatch, authSlice/* setAuthModalVisibility */.LY, sku, productInfo, true // post-login retry
                            );
                        } else {
                            getAnalyticsInfoOnclick("favorites", "success", t("kf.favorites.removeItem"));
                            dispatch((0,favoritesSlice/* removeItems */.Er)({
                                ids: [
                                    fav.id
                                ],
                                isDataLayerNeeded: false
                            })).unwrap().then((res)=>{
                                dispatch((0,genericSlice/* showToast */.CF)({
                                    message: toasterContent.unfavoriteSuccessMessage || t("kf.favorites.removeItem"),
                                    isVisible: true
                                }));
                            }).catch((err)=>{
                                getAnalyticsInfoOnclick("favorites", "failure", t("kf.favorites.removeItemError"));
                                dispatch((0,genericSlice/* showToast */.CF)({
                                    message: t("kf.favorites.removeItemError"),
                                    isVisible: true
                                }));
                            });
                        }
                    }
                });
            } else {
                if (!isAuthenticated) {
                    handleLogin(e, setLoginFavouriteCallback, dispatch, authSlice/* setAuthModalVisibility */.LY, sku, productInfo, true // post-login retry
                    );
                } else {
                    dispatch((0,favoritesSlice/* addProduct */.gK)(sku)).unwrap().then(()=>{
                        getAnalyticsInfoOnclick("favorites", "success", t("kf.favorites.success"));
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: toasterContent.successMessage || t("kf.favorites.success"),
                            isVisible: true
                        }));
                    }).catch((err)=>{
                        getAnalyticsInfoOnclick("favorites", "failure", t("kf.favorites.error"));
                        dispatch((0,genericSlice/* showToast */.CF)({
                            message: t("kf.favorites.error"),
                            isVisible: true
                        }));
                    });
                }
            }
            setLoginFavouriteCallback(null);
        };
        // Handle focus on save button to ensure it's visible past navigation menu
        const handleSaveButtonFocus = ()=>{
            if (!saveButtonRef.current) return;
            // Determine row cols based on width (same logic as ProductList)
            // Get the element's position
            const rect = saveButtonRef.current.getBoundingClientRect();
            const navHeight = 100 // Approximate navigation menu height, adjust as needed
            ;
            // Check if element is hidden behind navigation
            if (rect.top < navHeight) {
                // Scroll to make the element visible with some offset
                const scrollOffset = window.pageYOffset + rect.top - navHeight - 20;
                window.scrollTo({
                    top: scrollOffset,
                    behavior: "smooth"
                });
            }
        };
        (0,react.useEffect)(()=>{
            if (loginFavouriteCallback && isAuthenticated) {
                // Prevent guest analytics after login
                const callback = {
                    ...loginFavouriteCallback,
                    isPostLoginRetry: true
                };
                if (isSaveProductToList) {
                    dispatch((0,favoritesSlice/* getMyAccountListsWithLineItems */.WQ)()).unwrap().then((res)=>{
                        const userlistSKUS = res[0][1];
                        if (userlistSKUS[data["sku_s"]]) {
                            setOpenModal(true);
                            setDeleteFromList(true);
                        } else {
                            handleFavorite(callback);
                        }
                    });
                } else {
                    handleFavorite(callback);
                }
            }
        }, [
            loginFavouriteCallback,
            isAuthenticated
        ]);
        (0,react.useEffect)(()=>{
            const props = getProductTabData({
                data,
                isSterling,
                globalConfig,
                persona,
                handleOnClickPartsDiagramLink,
                compareData,
                compareErrorMessage,
                setCompareErrorMessage,
                compareChecked,
                setCompareChecked,
                favIconState,
                handleFavorite,
                swatchCount,
                setColorSku,
                colorSku,
                index,
                cartData,
                locale,
                searchResultDataLayerObj,
                brandSwitcherItems,
                type,
                width,
                paginationState,
                setCardLoader,
                setShowQuickViewModal,
                setScrollY,
                t,
                saveButtonRef,
                handleSaveButtonFocus
            });
            setMainProps(props);
        }, [
            compareChecked,
            compareErrorMessage,
            compareData,
            data,
            userListItemsSkus,
            favIconState,
            colorSku,
            stableSwatchCount
        ]);
        (0,react.useEffect)(()=>{
            let timeoutId;
            if (compareErrorMessage) {
                timeoutId = setTimeout(()=>{
                    setCompareErrorMessage("");
                }, 2000);
            }
            return ()=>clearTimeout(timeoutId);
        }, [
            compareErrorMessage
        ]);
        (0,react.useEffect)(()=>{
            const isCurrentlyFavorite = userListItemsSkus[data.sku_s] ? true : null;
            const newIsSaved = getFavIconStatus(isSaveProductToList, productSavedToList, {
                current: userListItemsSkus
            }, {
                current: favorites
            }, data.sku_s, data.ctId_s, isCurrentlyFavorite);
            setFavIconState(newIsSaved);
            setIsFavorite((favorites === null || favorites === void 0 ? void 0 : favorites.find((vl)=>vl.productId === data["ctId_s"])) ? true : false);
        }, [
            favIconState,
            showAddToList,
            openModal,
            deleteFromList,
            userListItemsSkus,
            favorites,
            isFavorite,
            isAuthenticated,
            data
        ]);
        (0,react.useEffect)(()=>{
            if ((compareData === null || compareData === void 0 ? void 0 : compareData.comparedProducts.find((prod)=>prod.compareSku === data.sku_s)) && compareErrorMessage === "") {
                setCompareChecked(true);
            } else {
                setCompareChecked(false);
            }
        }, [
            compareData,
            data,
            compareErrorMessage
        ]);
        const handleQuickViewHide = async ()=>{
            if (scrollY) {
                window.scrollTo({
                    top: parseInt(scrollY, 10),
                    behavior: "instant"
                });
            }
            setScrollY(0);
            setShowQuickViewModal(false);
            sessionStorage.removeItem("plpScrollSku") // back=K-T13140-4A-CP
            ;
            sessionStorage.removeItem("plpCurrentRows");
            mainProps.getAnalyticsInfoOnclick("quick_view_close");
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "product-list-tile__wrapper wow",
            children: [
                cardLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "spinner-overlay",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
                        mod: "white"
                    })
                }),
                isSterling ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                    size: "h5",
                    className: "family-of-brands",
                    children: t("kf.viewFamilyResults")
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(WrappedComponent, {
                    ...mainProps.productTabProps
                }),
                isSterling ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    ...mainProps.sterlingButtonProps
                }) : null,
                openModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListConfirmationModal/* default */.Z, {
                    openConforMationModal: openModal,
                    deleteFromList: deleteFromList,
                    closeConformationModal: ()=>setOpenModal(false),
                    list: userListItemsSkus[data.sku_s],
                    deleteConfirmationModal: ()=>setProductSavedToList(false)
                }) : showAddToList ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveToList/* default */.Z, {
                    productSku: data.sku_s,
                    showListSaveAndCreate: showAddToList,
                    listSaveAndCreateClose: ()=>{
                        setShowAddToList(false);
                    },
                    handleSuccessCallBack: handleSaveToListSuccessCallBack
                }) : null,
                showQuickViewModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
                    showModal: showQuickViewModal,
                    onModalClose: handleQuickViewHide,
                    className: "quickview-modal",
                    fromPLP: true,
                    fromSearch: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickView, {
                        productData: data,
                        closeModal: handleQuickViewHide,
                        authorData: quickViewAuthData,
                        quickViewSelectedSku: data.sku_s,
                        plp: true,
                        search: true
                    })
                }) : null
            ]
        });
    };
};
/* harmony default export */ var ProductTileHOC = (productTileHoc);

;// CONCATENATED MODULE: ./components/Shared/ProductList/v2/ProductTile/V2/ProductTileUI.jsx



const ProductCardUI = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard/* ProductCard */.I, {
        ...props
    });
};
/* harmony default export */ var ProductTileUI = (ProductTileHOC(ProductCardUI));

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Cards/PromotionalTilePLP/PromotionalTilePLP.mjs + 2 modules
var PromotionalTilePLP = __webpack_require__(22367);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./components/Shared/Search/v1/InspirationTile/analytics/constant.js
var analytics_constant = __webpack_require__(67491);
// EXTERNAL MODULE: ./utils/textUtils.js
var textUtils = __webpack_require__(89299);
// EXTERNAL MODULE: ./utils/location.js
var utils_location = __webpack_require__(97433);
;// CONCATENATED MODULE: ./components/PromoBanner/v3/PromoBannerHelper.js






const getPromoData = async (link)=>{
    const finalData = (0,api/* aemAxiosInstance */.Gb)({
        url: constants.GLOBAL_CONFIGURATION_ENDPOINT,
        params: {
            path: link + ".model.json"
        }
    }).then((res)=>{
        const dat = (0,utils/* recursiveDataFunction */.Qe)(res === null || res === void 0 ? void 0 : res.data, constants.COMPONENT_TYPES === null || constants.COMPONENT_TYPES === void 0 ? void 0 : constants.COMPONENT_TYPES.PROMOBANNER);
        return dat[0];
    }).catch((err)=>{
        console.log("Failed to get compare attributes JSON file", err);
    });
    return finalData;
};
const getAnalyticsDataLayer = (data, promoIndex, shortenedUrl)=>{
    const ctaLink = data === null || data === void 0 ? void 0 : data.ctaLabel.toLowerCase();
    const componentInfo = {
        eventAction: "".concat(analytics_constant/* SEARCH_RESULTS */.fP, ":").concat(constants.SEARCH_TABS.PRODUCTS, ":").concat(analytics_constant/* MAIN_CONTENT_AREA */.mb, ":").concat(ctaLink),
        eventName: "".concat(analytics_constant/* SEARCH_RESULTS */.fP, ":").concat(constants.SEARCH_TABS.PRODUCTS, ":").concat(analytics_constant/* MAIN_CONTENT_AREA */.mb, ":").concat(ctaLink),
        componentMessage: "promo-".concat(promoIndex),
        componentName: (0,textUtils/* sanitizeText */.o)(data === null || data === void 0 ? void 0 : data.title).toLowerCase(),
        componentType: "internal campaign"
    };
    const eventInfo = {
        eventAction: "".concat(analytics_constant/* SEARCH_RESULTS */.fP, ":").concat(constants.SEARCH_TABS.PRODUCTS, ":").concat(analytics_constant/* MAIN_CONTENT_AREA */.mb, ":").concat(ctaLink),
        eventName: "".concat(analytics_constant/* SEARCH_RESULTS */.fP, ":").concat(constants.SEARCH_TABS.PRODUCTS, ":").concat(analytics_constant/* MAIN_CONTENT_AREA */.mb, ":").concat(ctaLink),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: ctaLink,
        internalLinkPosition: "search",
        internalLinkType: "".concat(analytics_constant/* SEARCH_RESULTS */.fP, ":internal campaign"),
        internalLinkZoneName: "".concat(analytics_constant/* SEARCH_RESULTS */.fP, ":").concat(constants.SEARCH_TABS.PRODUCTS, ":").concat(analytics_constant/* MAIN_CONTENT_AREA */.mb),
        internalLinkURL:  true ? window.location.origin + shortenedUrl : 0,
        clickInternalLinks: "true"
    };
    if (window.adobeDataLayer) {
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        window.adobeDataLayer.push({
            event: "cmp:click",
            componentInfo,
            eventInfo,
            page
        });
    }
};
const scrollToTop = ()=>{
    const scrollStep = -window.scrollY / (1000 / 15 // scroll speed here
    );
    const scrollInterval = setInterval(()=>{
        if (window.scrollY !== 0) {
            window.scrollBy(0, scrollStep);
        } else {
            clearInterval(scrollInterval);
        }
    }, 15);
};
const setPromoJsonData = async function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, promoIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, desktopPromo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "one-column";
    // Store the shortened URL in a separate variable
    const shortenedUrl = await (0,utils_location/* getShortenedUrl */.Pp)(data === null || data === void 0 ? void 0 : data.ctaLink);
    const promoProps = {
        mod: "black",
        promoKey: "promo-".concat(promoIndex),
        heading: {
            text: (0,textUtils/* sanitizeText */.o)(data === null || data === void 0 ? void 0 : data.title) || ""
        },
        image: {
            src: data === null || data === void 0 ? void 0 : data.imageUrl,
            alt: data === null || data === void 0 ? void 0 : data.altText,
            "data-mode": "smartcrop",
            role: "presentation"
        },
        CTA: {
            text: data === null || data === void 0 ? void 0 : data.ctaLabel,
            href: shortenedUrl,
            target: (data === null || data === void 0 ? void 0 : data.isNewTab) === "true" ? "_blank" : "_self",
            onClick: ()=>{
                if (shortenedUrl === window.location.pathname) {
                    scrollToTop();
                }
                getAnalyticsDataLayer(data, promoIndex, shortenedUrl);
            }
        },
        textPlacement: (0,textUtils/* normalizePromoTextPlacement */.W)(data === null || data === void 0 ? void 0 : data.contentPosition),
        gradientDirection: constants.GRADIENT_DICTIONARY[data === null || data === void 0 ? void 0 : data.gradientPosition[0]],
        opacity: parseInt(data === null || data === void 0 ? void 0 : data.gradientOpacity),
        type: constants.PROMO_COLUMNS[desktopPromo],
        style: (()=>{
            return {
                aspectRatio: "1 / 1"
            };
        })()
    };
    return promoProps;
};
const getPromoBannerProps = async (param)=>{
    let { xfLink , promoIndex =0 , desktopPromo  } = param;
    if (xfLink) {
        const link = xfLink === null || xfLink === void 0 ? void 0 : xfLink.split(".html")[0];
        if (link) {
            try {
                const data = await getPromoData(link);
                const promoProps = await setPromoJsonData(data, promoIndex, desktopPromo);
                return promoProps;
            } catch (error) {
                console.error(error);
                return null;
            }
        }
    }
};

;// CONCATENATED MODULE: ./components/PromoBanner/v3/PromoBanner.jsx





const PromoBannerV2 = (param)=>{
    let { xfLink , promoIndex , desktopPromo  } = param;
    const [promoData, setPromoData] = (0,react.useState)(null);
    (0,react.useEffect)(()=>{
        const loadPromo = async ()=>{
            const data = await getPromoBannerProps({
                xfLink,
                promoIndex,
                desktopPromo
            });
            setPromoData(data);
        };
        loadPromo();
    }, [
        xfLink
    ]);
    // Optional loading state
    if (!promoData) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionalTilePLP/* PromotionalTilePLP */.M, {
        ...promoData
    });
};
/* harmony default export */ var PromoBanner = (PromoBannerV2);
PromoBannerV2.propTypes = {
    xfLink: (prop_types_default()).string,
    promoIndex: (prop_types_default()).number,
    desktopPromo: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/Search/v1/ProductsTab/index.jsx































const ProductsTab = (param)=>{
    let { staticTexts ={} , totalSearchResults =0 , count =0 , searchKeyword ="" , onSearch =()=>{} , type ="" , page ="" , currencySign ="" , lwAppName ="" , query: queryProp = "" , isLandscape =false , componentProps: { disableBestSellers =false , isAnnsacksPlp =""  } = {} , marketParamValues =[] , isSterling =false , sterlingData =[] , brand ="" , forceTabLoader =false , brandSwitcherItems =[] , quickViewAuthData ={}  } = param;
    var ref;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { searchDetails ={} , searchResponse: { data: { fusion: searchFusion = {}  } = {}  } = {}  } = (0,es/* useSelector */.v9)(searchSlice/* searchState */.uv);
    const { data =[] , total , facets =[] , facetLabels , status , colors , fusion ={}  } = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv).plp;
    const retainedFilters = searchDetails.keyword === searchKeyword && ((ref = searchDetails[type]) === null || ref === void 0 ? void 0 : ref.filters) ? searchDetails[type].filters : [];
    const { access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const productsPerPage = constants.PRODUCTS_PER_PAGE;
    const [width] = (0,useWindowResize/* default */.Z)();
    const initialPartData = {
        productId: "",
        partId: "",
        isShowModal: false
    };
    const [showFilter, setShowFilter] = (0,react.useState)(width >= 1024 ? true : false);
    const [rowCols, setRowCols] = (0,react.useState)(width < 1024 ? 2 : 3);
    const [sessionId, setSessionId] = (0,react.useState)("");
    const [paginationState, setPaginationState] = (0,react.useState)({
        curRows: parseInt(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.plpCurrentRows) || 30,
        start: 0
    });
    const { curRows , start  } = paginationState;
    const prevRows = (0,usePrevious/* default */.Z)(curRows);
    var ref1;
    const [scrollToSku, setScrollToSku] = (0,react.useState)((ref1 = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.plpScrollSku) !== null && ref1 !== void 0 ? ref1 : "");
    const filterModalWindow = (0,react.useRef)(null);
    const [selectedSort, setSelectedSort] = (0,react.useState)({});
    const [filterQueries, setFilterQueries] = (0,react.useState)(retainedFilters.length > 0 ? retainedFilters : []);
    const [swatchCount, setSwatchCount] = (0,react.useState)(5);
    const [xfLink, setXfLink] = (0,react.useState)("");
    const [partData, setPartsData] = (0,react.useState)(initialPartData);
    const [fusionQueryId, setFusionQueryId] = (0,react.useState)("");
    const [dataPopulated, setDataPopulated] = (0,react.useState)(false);
    const [dataInitPopulated, setDataInitPopulated] = (0,react.useState)(false);
    const [isFusionLoaded, setIsFusionLoaded] = (0,react.useState)(false);
    const [isRendering, setIsRendering] = (0,react.useState)(true);
    const [zeroResults, setZeroResults] = (0,react.useState)(false);
    const [localData, setLocalData] = (0,react.useState)(data);
    const [isLoadMore, setIsLoadMore] = (0,react.useState)(false);
    const [svgFileMap, setSvgFileMap] = (0,react.useState)([]);
    const [scrollPosition, setScrollPosition] = (0,react.useState)(0);
    const searchResultDataLayerObj = {
        searchResult: totalSearchResults,
        searchTerm: searchKeyword,
        searchResultCategoryType: type === null || type === void 0 ? void 0 : type.toLowerCase(),
        searchResultCategoryTypeCount: count
    };
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = (0,MyList_localization/* getTranslations */.F)(t);
    (0,react.useEffect)(()=>{
        const selectedSortItem = (0,helper/* getSortItemBasedOnURL */.KE)(staticTexts, {
            name: staticText.featured
        });
        setSelectedSort(selectedSortItem);
    }, []);
    (0,react.useEffect)(()=>{
        const cookie = document === null || document === void 0 ? void 0 : document.cookie;
        const cookieArray = cookie === null || cookie === void 0 ? void 0 : cookie.split(";");
        const sessionCookie = cookieArray.filter((item)=>{
            return item === null || item === void 0 ? void 0 : item.includes("session#");
        })[0];
        const sessionIdString = sessionCookie === null || sessionCookie === void 0 ? void 0 : sessionCookie.split("|")[1];
        setSessionId(sessionIdString === null || sessionIdString === void 0 ? void 0 : sessionIdString.split("#")[1]);
    }, []);
    (0,react.useEffect)(()=>{
        setSwatchCount((0,helper/* getSwatchCountSearch */.iZU)(width));
    }, [
        width
    ]);
    // Reset filterQueries when tab type changes to trigger fresh data load
    (0,react.useEffect)(()=>{
        var ref;
        const newFilters = searchDetails.keyword === searchKeyword && ((ref = searchDetails[type]) === null || ref === void 0 ? void 0 : ref.filters) ? searchDetails[type].filters : [];
        setFilterQueries(newFilters);
        setPaginationState({
            curRows: 30,
            start: 0
        });
    }, [
        type
    ]);
    (0,react.useEffect)(()=>{
        // Set isRendering to false when we have data or when loading is complete
        if (status !== "loading" || data.length > 0) {
            setIsRendering(false);
        }
    }, [
        status,
        data
    ]);
    (0,react.useEffect)(()=>{
        if (isSterling && sterlingData.length > 0) {
            setLocalData(sterlingData);
        } else {
            setLocalData(data);
        }
    }, [
        isSterling,
        data
    ]);
    (0,react.useEffect)(()=>{
        if (dataInitPopulated && typeof total !== "undefined" && total === 0) {
            setZeroResults(true);
        } else {
            setZeroResults(false);
        }
    }, [
        dataInitPopulated,
        total
    ]);
    (0,react.useEffect)(()=>{
        const search = window.location.search;
        if (!isEmpty_default()(searchFusion) && accessToken && !isFusionLoaded) {
            setIsFusionLoaded(true);
            if (retainedFilters.length > 0) {
                setFilterQueries(retainedFilters);
            } else {
                const filterQuery = (0,helper/* getAllFilterQueries */.ud4)({
                    attributeName: ""
                }, searchFusion, marketParamValues);
                if (!search.includes("tab=")) {
                    setFilterQueries(filterQuery);
                    dispatch((0,searchSlice/* setSearchFilter */.Qf)({
                        queries: filterQuery,
                        key: type
                    }));
                } else {
                    if (search.includes("tab=".concat(type))) {
                        setFilterQueries(filterQuery);
                        dispatch((0,searchSlice/* setSearchFilter */.Qf)({
                            queries: filterQuery,
                            key: type
                        }));
                    }
                }
                (0,helper/* retainSearchQueryParams */.mSA)(type);
            }
        }
    }, [
        searchFusion,
        accessToken
    ]);
    (0,react.useEffect)(()=>{
        if (accessToken && filterQueries !== null && filterQueries !== undefined) {
            // will trigger from onLoadMore
            if (start) {
                generateListingUrl(isLoadMore, false);
            // Will trigger when user coming back from PDP page
            } else if (start === 0 && scrollToSku) {
                setScrollToSku("");
                generateListingUrl(false, true);
            } else if (start === 0 && curRows && !!prevRows && prevRows > curRows) {
                generateListingUrl(false, true);
            } else if (start === 0 && curRows) {
                generateListingUrl(false, false);
            }
        }
    }, [
        accessToken,
        start,
        curRows,
        selectedSort,
        filterQueries,
        isLoadMore,
        type
    ]);
    (0,react.useEffect)(()=>{
        if ((fusion === null || fusion === void 0 ? void 0 : fusion.fusionQueryId) !== undefined) {
            setFusionQueryId(fusion.fusionQueryId);
        }
        if (fusion && (fusion === null || fusion === void 0 ? void 0 : fusion.experiment_fragments) && (fusion === null || fusion === void 0 ? void 0 : fusion.experiment_fragments) !== undefined) {
            var ref;
            var ref1;
            setXfLink((ref1 = (ref = fusion === null || fusion === void 0 ? void 0 : fusion.experiment_fragments[0]) === null || ref === void 0 ? void 0 : ref.url_s) !== null && ref1 !== void 0 ? ref1 : "");
        }
    }, [
        fusion
    ]);
    (0,react.useEffect)(()=>{
        // To scrollup the product list on back
        if (dataPopulated) (0,ProductsTab_helper/* scrollToProductV2 */.N4)();
    }, [
        dataPopulated
    ]);
    (0,react.useEffect)(()=>{
        switch(true){
            case width > 1023:
                setRowCols(3);
                break;
            default:
                setRowCols(2);
        }
    }, [
        isLandscape,
        width
    ]);
    const tileClass = classnames_default()({
        "product-listing__tile-col": true,
        "product-listing__tile-col--full-width": !showFilter
    });
    const filterClass = classnames_default()({
        "product-listing__filter": true,
        "product-listing__filter--hide": !showFilter,
        "product-listing__filter--modal": showFilter
    });
    const sortList = (0,ProductsTab_helper/* getSortList */.ur)(staticTexts);
    const sortsCopy = [
        ...sortList
    ];
    sortsCopy.splice(sortsCopy.findIndex((a)=>a.query === "bestSeller_l+asc"), 1);
    const customizedSort = disableBestSellers ? sortsCopy : sortList;
    // calculate promo position
    const col = width < 768 ? {
        "one-column": "promo-col-3",
        "two-column": "promo-col-3",
        "three-column": "promo-col-3"
    } : width > 768 && width < 1024 ? {
        "one-column": "promo-col-1",
        "two-column": "promo-col-3",
        "three-column": "promo-col-3"
    } : {
        "one-column": "promo-col-1",
        "two-column": "promo-col-2",
        "three-column": "promo-col-3"
    };
    const promoPosition = width < 767 ? 3 : width < 1024 ? 4 : 7;
    const handleSort = (item)=>{
        setPaginationState((state)=>({
                ...state,
                start: 0
            }));
        setSelectedSort(item);
        (0,helper/* replaceSearchUrl */.CjH)("sort", item === null || item === void 0 ? void 0 : item.query);
        (0,helper/* replaceSearchUrl */.CjH)("tab", type);
        (0,helper/* retainSearchQueryParams */.mSA)(type);
        (0,ProductsTab_helper/* scrollToFirstProduct */.nj)();
    };
    const handleFilter = (queries)=>{
        setIsLoadMore(false);
        dispatch((0,searchSlice/* setSearchFilter */.Qf)({
            queries,
            key: type
        }));
        setFilterQueries(queries);
        (0,ProductsTab_helper/* scrollToFirstProduct */.nj)();
    };
    const generateListingUrl = function(update) {
        let enableScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, queries = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : filterQueries !== null && filterQueries !== void 0 ? filterQueries : [];
        const personaTemp = (0,helper/* getUserPersona */.shu)();
        const sessionRows = (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.plpCurrentRows) ? parseInt(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.plpCurrentRows) : curRows;
        // check this
        const callStart = (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.plpCurrentRows) ? 0 : start;
        const fq = (0,ProductsTab_helper/* getFilterQuery */.sR)(type, queryProp, queries, personaTemp);
        const fl = (0,ProductsTab_helper/* getFlData */.c9)(personaTemp);
        const query = {
            fq,
            rows: sessionRows,
            start: isLoadMore ? callStart : 0
        };
        if (selectedSort.name !== staticTexts.Featured) {
            if (selectedSort.query === "price+asc") {
                query.sort = "".concat((0,helper/* getPriceSortQuery */.YHw)(), "+asc");
            } else if (selectedSort.query === "price+desc") {
                query.sort = "".concat((0,helper/* getPriceSortQuery */.YHw)(), "+desc");
            } else {
                query.sort = selectedSort.query;
            }
        }
        const arg = {
            q: searchKeyword,
            fl: fl.join(","),
            ...query,
            profileName: type === "Parts" ? "profile_service_parts_Search" : "profile_".concat(lwAppName.toLowerCase(), "_Search"),
            collections: type === "Parts" ? "service_parts" : lwAppName.toLowerCase(),
            displaytype: "search",
            update
        };
        if (enableScroll) setDataPopulated(false);
        setDataInitPopulated(false);
        dispatch((0,productListSlice/* getProducts */.Xp)({
            ...arg
        })).unwrap().then((obj)=>{
            setDataInitPopulated(true);
            if (enableScroll) setDataPopulated(true);
            // Update the count in Redux searchDetails for this tab
            if (obj && obj.data && obj.data.total !== undefined) {
                dispatch((0,searchSlice/* setSearchTabCount */.u1)({
                    tabType: type,
                    count: obj.data.total
                }));
            }
        }).catch(()=>{
            setDataInitPopulated(false);
            if (enableScroll) setDataPopulated(false);
        });
    };
    const handleOnClickPartsDiagramLink = (data)=>{
        const scrollY = window === null || window === void 0 ? void 0 : window.scrollY;
        const getPartId = get_default()(data, "ProductResource.InteractiveSVG.resourceName_ss", "");
        const resourceTitles = get_default()(data, "ProductResource.InteractiveSVG.resourceTitle_ss", "");
        const partId = Array.isArray(getPartId) ? getPartId[0] : getPartId;
        setPartsData({
            partId,
            productId: data.ProductProductNo_s,
            isShowModal: true
        });
        const partLinks = (0,helper/* organizeData */.U2t)(getPartId, resourceTitles, "Service Parts Diagram", "PART");
        setSvgFileMap(partLinks);
        setScrollPosition(scrollY);
    };
    const executeScroll = ()=>{
        modules/* scroller.scrollTo */.OK.scrollTo("products-tab", {
            duration: 1500,
            delay: 0,
            smooth: "easeInOutQuart"
        });
    };
    // Will trigger when pagination changes
    const onRows = (rows)=>{
        setPaginationState({
            start: 0,
            curRows: rows
        });
    };
    // Will trigger on load more clicks
    const onLoadMore = ()=>{
        setIsLoadMore(true);
        setPaginationState((state)=>({
                ...state,
                start: start + curRows
            }));
    };
    const handleBackToTop = ()=>{
        var ref;
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        (ref = document.getElementById("kf-product-list-tile-details-0")) === null || ref === void 0 ? void 0 : ref.focus();
    };
    const onCloseModal = ()=>{
        setPartsData({
            ...initialPartData,
            isShowModal: false
        });
        if (scrollPosition) {
            window.scrollTo({
                top: parseInt(scrollPosition, 10),
                behavior: "instant"
            });
        }
        setScrollPosition(0);
    };
    const { productId ="" , partId ="" , isShowModal =false  } = partData;
    let promoIndex = 0;
    const { featureFlags ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { MYSQLCONNSTR_ENABLE_PARTS_VIEWER_V2: isPartsViewerV2Enabled = false  } = featureFlags;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((ProductListView_index_module_default()).productListWrapper, " ").concat((ProductTile_index_module_default()).productTileWrapper, " ").concat((Sort_index_module_default()).productListingSearchWrapper, " ").concat((Filter_index_module_default()).productListingFilterWrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-listing",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stickyNavHeader["default"], {
                        showFilter: showFilter,
                        rowCols: rowCols,
                        setShowFilter: setShowFilter,
                        setRowCols: setRowCols,
                        staticTexts: staticTexts,
                        sorts: customizedSort,
                        selectedSort: selectedSort,
                        handleSort: handleSort,
                        totalResults: totalSearchResults,
                        searchKeyword: searchKeyword,
                        onSearch: onSearch,
                        type: type,
                        page: page,
                        isSearchTab: true,
                        brand: brand,
                        searchDetails: searchDetails
                    }),
                    !isRendering && !forceTabLoader ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container kf-react-plp-container product-listing__tiles",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-listing__row d-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "filter-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: filterClass,
                                        "aria-modal": true,
                                        ref: filterModalWindow,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-listing__filter--sticky",
                                            "aria-hidden": !showFilter,
                                            onKeyDown: (e)=>(0,ProductsTab_helper/* handleKeyPress */.n4)(e, width, filterModalWindow, setShowFilter),
                                            children: facets && /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter["default"], {
                                                tabIndex: "0",
                                                page: page,
                                                texts: staticTexts,
                                                currencySign: currencySign,
                                                facetData: facets,
                                                facetLabels: facetLabels,
                                                currFilters: filterQueries,
                                                sort: customizedSort,
                                                selectedSort: selectedSort,
                                                onSortChange: handleSort,
                                                selectedFilterCount: filterQueries && filterQueries.reduce((acc, item)=>{
                                                    return acc + item.value.length;
                                                }, 0),
                                                onFilter: handleFilter,
                                                close: setShowFilter,
                                                colors: colors,
                                                displayShare: true,
                                                displayPrint: true,
                                                handleScroll: executeScroll,
                                                showFilter: showFilter,
                                                totalResults: total,
                                                showSort: (0,helper/* shouldShowSortElement */._AA)(page),
                                                type: type || "products",
                                                isAnnsacksPlp: isAnnsacksPlp,
                                                addToUrl: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: tileClass,
                                        children: localData.length === 0 ? count === 0 || zeroResults ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-list__no-results",
                                            dangerouslySetInnerHTML: {
                                                __html: staticTexts.searchNoResultErrorMessage
                                            }
                                        }) : null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-listing__row row-cols-".concat(rowCols),
                                                    children: localData.map((product, i)=>{
                                                        var ref;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-listing__tile",
                                                                    id: "K-" + product["sku_s"],
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                                                        className: "kf-lazyload-wrapper",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTileUI, {
                                                                            data: product,
                                                                            highlightText: searchKeyword,
                                                                            index: i,
                                                                            swatchCount: swatchCount,
                                                                            handleOnClickPartsDiagramLink: handleOnClickPartsDiagramLink,
                                                                            parent: "search",
                                                                            isSterling: isSterling,
                                                                            searchResultDataLayerObj: searchResultDataLayerObj,
                                                                            fusionQueryId: fusionQueryId,
                                                                            sessionId: sessionId,
                                                                            brandSwitcherItems: brandSwitcherItems,
                                                                            type: type,
                                                                            paginationState: paginationState,
                                                                            quickViewAuthData: quickViewAuthData
                                                                        })
                                                                    })
                                                                }, "".concat(i, "-").concat(product.Product_Category, "-").concat(product.ctId_s)),
                                                                xfLink && i === promoPosition && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat(col["one-column"], " product-listing__tile"),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoBanner, {
                                                                        xfLink: xfLink,
                                                                        promoIndex: ++promoIndex,
                                                                        desktopPromo: (ref = fusion === null || fusion === void 0 ? void 0 : fusion.experiment_fragments[0]) === null || ref === void 0 ? void 0 : ref.promoLayout_s
                                                                    })
                                                                })
                                                            ]
                                                        }, "".concat(i, "-").concat(product.Product_Category, "-").concat(product.ctId_s));
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                                    displayShare: true,
                                                    displayPrint: true,
                                                    totalResults: isSterling ? 1 : total,
                                                    isSearchTab: true,
                                                    staticTexts,
                                                    onLoadMore,
                                                    curRows,
                                                    data,
                                                    productsPerPage,
                                                    onRows,
                                                    handleBackToTop,
                                                    width,
                                                    page,
                                                    type
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_TabLoader, {})
                ]
            }),
            isPartsViewerV2Enabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v2_PartsViewer/* default */.Z, {
                productId: productId,
                partId: partId,
                showModal: isShowModal,
                page: page + " results",
                onClose: onCloseModal,
                fileMap: svgFileMap
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsViewer/* default */.Z, {
                productId: productId,
                partId: partId,
                showModal: isShowModal,
                page: page + " results",
                onClose: onCloseModal
            })
        ]
    });
};
/* harmony default export */ var v1_ProductsTab = (ProductsTab);

// EXTERNAL MODULE: ./components/Default/DynamicSearch/v1/analytics.js
var v1_analytics = __webpack_require__(33507);
;// CONCATENATED MODULE: ./components/Search/v1/Search.jsx

















const SearchComponent = (props)=>{
    var ref, ref1, ref2, ref3;
    const dispatch = (0,es/* useDispatch */.I0)();
    const newState = (0,es/* useSelector */.v9)(searchSlice/* searchState */.uv);
    const { plp: { total: filteredTotalResults = 0  } = {}  } = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv);
    const { searchResponse , searchDetails  } = newState;
    const productsPerPage = constants.PRODUCTS_PER_PAGE;
    const { data: componentProp , header: headerProps  } = props;
    const [total, setTotal] = (0,react.useState)(0);
    const [selected, setSelected] = (0,react.useState)({});
    const [partsData, setPartsData] = (0,react.useState)({});
    const [searchKeyword, setSearchKeyword] = (0,react.useState)("");
    const [searchMainKeyword, setSearchMainKeyword] = (0,react.useState)("");
    const [loading, setLoading] = (0,react.useState)(true);
    const [exactMatch, setExactMatch] = (0,react.useState)(false);
    const [tagDebug, setTagDebug] = (0,react.useState)(true);
    const [searchClickEvent, setSearchClickEvent] = (0,react.useState)(false);
    const [debounceInProgress, setDebounceInProgress] = (0,react.useState)(false);
    const [isFromServicePart, setIsFromServicePart] = (0,react.useState)(false);
    const [general, setGeneral] = (0,react.useState)();
    const [isInitialLoad, setIsInitialLoad] = (0,react.useState)(true);
    // eslint-disable-next-line no-unused-vars
    const [info, setInfo] = (0,react.useState)({});
    const [loadPopularSearch, setLoadPopularSearch] = (0,react.useState)(false);
    const [isSterling, setIsSterling] = (0,react.useState)(false);
    const [plpBadge, setPlpBadge] = (0,react.useState)({});
    const [searchClear, setSearchClear] = (0,react.useState)(null);
    const [searchTagger, setSearchTagger] = (0,react.useState)(null);
    const [tabResultCounts, setTabResultCounts] = (0,react.useState)(constants.INITIAL_SEARCH_TABS_COUNT);
    const pageLoadedRef = (0,react.useRef)(false);
    const staticTexts = (0,useSearchi18n/* default */.Z)({
        componentProp
    });
    const brandSwitcherItems = (0,utils/* getBrandSwitcher */.o4)(headerProps);
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then(async (config)=>{
            var ref;
            const { plpConfigurations: { myArrayList: plpBadgeList = []  } = {}  } = config;
            var ref1;
            const brandName = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.siteName) !== null && ref1 !== void 0 ? ref1 : "";
            const locale = get_default()(config, "internationalization.locale", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const knowledgeArticleUrl = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.knowledgeArticlePath", ""));
            const marketParamValues = get_default()(config, "marketParamValues");
            const { general: { lwAppName =""  } = {}  } = config !== null && config !== void 0 ? config : {};
            const info = {
                locale: locale,
                currencySign: currencySign,
                currencyCode: currencyCode,
                knowledgeArticleUrl: knowledgeArticleUrl,
                lwAppName
            };
            var ref2;
            const displayOrderBadges = (ref2 = plpBadgeList.find((item)=>item.map.Key === "displayOrderBadges")) !== null && ref2 !== void 0 ? ref2 : {};
            const { map: { Values: { myArrayList: displayOrderBadgeList = []  } = {}  } = {}  } = displayOrderBadges;
            const plpBadges = {};
            displayOrderBadgeList.forEach((item)=>{
                plpBadges[item] = (0,helper/* getBadgeValue */.FcF)(item, plpBadgeList);
            });
            const general = {
                brandName: brandName,
                marketParamValues: marketParamValues,
                lwAppName: lwAppName
            };
            setInfo(info);
            setGeneral(general);
            setPlpBadge({
                plpBadges,
                displayOrderBadgeList
            });
            setTimeout(function() {
                setIsInitialLoad(false);
            }, 2000);
        }, []);
        try {
            var ref, ref1;
            const urlParams = new URL(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href);
            if (urlParams === null || urlParams === void 0 ? void 0 : (ref1 = urlParams.searchParams) === null || ref1 === void 0 ? void 0 : ref1.get("keyword")) {
                var ref2;
                const keyword = decodeURIComponent(urlParams === null || urlParams === void 0 ? void 0 : (ref2 = urlParams.searchParams) === null || ref2 === void 0 ? void 0 : ref2.get("keyword"));
                const isFromServicePart = decodeURIComponent(urlParams === null || urlParams === void 0 ? void 0 : urlParams.searchParams.get("service"));
                if ((keyword === null || keyword === void 0 ? void 0 : keyword.length) < 3) {
                    setSearchKeyword(keyword);
                    dispatch((0,searchSlice/* setSearchKeyword */.Ec)(keyword));
                    setLoadPopularSearch(true);
                    setLoading(false);
                } else {
                    setSearchKeyword(keyword);
                    dispatch((0,searchSlice/* setSearchKeyword */.Ec)(keyword));
                    setIsFromServicePart(isFromServicePart === "true");
                    setLoading(true);
                }
            } else {
                setLoadPopularSearch(true);
                setLoading(false);
            }
        } catch (error) {
            setLoadPopularSearch(true);
            setLoading(false);
            console.error("URIError: malformed URI sequence");
        }
        return ()=>{
            sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.removeItem("previousPageNameForSearch");
        };
    }, []);
    const tabList = [];
    let activeTab;
    (0,react.useEffect)(()=>{
        if (tabList.length && activeTab >= 0) {
            const newTabCounts = {
                ...tabResultCounts,
                [tabList[activeTab]["id"]]: filteredTotalResults
            };
            setTabResultCounts(newTabCounts);
            const newTotal = Object.values(newTabCounts).reduce((acc, curr)=>acc + curr, 0);
            setTotal(newTotal);
        }
    }, [
        filteredTotalResults,
        tabList === null || tabList === void 0 ? void 0 : tabList.length,
        activeTab
    ]);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        const fullcatalogResponse = searchResponse === null || searchResponse === void 0 ? void 0 : (ref = searchResponse.data) === null || ref === void 0 ? void 0 : (ref1 = ref.fusion) === null || ref1 === void 0 ? void 0 : ref1.full_catalog_Response;
        if (fullcatalogResponse === null || fullcatalogResponse === void 0 ? void 0 : fullcatalogResponse.length) {
            if (fullcatalogResponse[0]["Brand_ss"][0] === "Sterling") {
                setIsSterling(true);
            }
        } else {
            setIsSterling(false);
        }
    }, [
        searchResponse
    ]);
    (0,react.useEffect)(()=>{
        if (general) {
            if ((searchKeyword === null || searchKeyword === void 0 ? void 0 : searchKeyword.length) > 1 && isInitialLoad) {
                var ref, ref1;
                (ref1 = getResults(searchKeyword, general === null || general === void 0 ? void 0 : (ref = general.brandName) === null || ref === void 0 ? void 0 : ref.toLowerCase(), searchClear, searchTagger)) === null || ref1 === void 0 ? void 0 : ref1.catch(()=>{});
                setSearchMainKeyword(searchKeyword);
                (0,helper/* removeSearchQueryParams */.FvC)();
                setIsInitialLoad(false);
            }
        }
    }, [
        searchKeyword,
        tagDebug,
        general
    ]);
    const handleSearch = (keyword, clear, tagger)=>{
        if (searchDetails.keyword !== keyword) {
            dispatch((0,searchSlice/* setActiveTabDispatch */.az)(0));
        }
        setSearchKeyword(keyword);
        setTagDebug(!tagger);
        setDebounceInProgress(true);
        setSearchClear(clear);
        setSearchTagger(tagger);
        dispatch((0,searchSlice/* setSearchKeyword */.Ec)(keyword));
        if ((keyword === null || keyword === void 0 ? void 0 : keyword.length) === 0 || (keyword === null || keyword === void 0 ? void 0 : keyword.length) === 1) {
            setTotal(0);
            setLoadPopularSearch(true);
            setTimeout(()=>{
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }, 50);
            setUrlParam(keyword);
        } else if ((keyword === null || keyword === void 0 ? void 0 : keyword.length) > 1) {
            var ref, // Call getResults directly with the clear and tagger values
            ref1;
            // Clear old search and product data before starting new search
            dispatch((0,searchSlice/* clearSearchResults */.Ug)());
            dispatch((0,productListSlice/* clearProductData */.sR)());
            setLoading(true);
            (ref1 = getResults(keyword, general === null || general === void 0 ? void 0 : (ref = general.brandName) === null || ref === void 0 ? void 0 : ref.toLowerCase(), clear, tagger)) === null || ref1 === void 0 ? void 0 : ref1.catch(()=>{});
            setSearchMainKeyword(keyword);
            (0,helper/* removeSearchQueryParams */.FvC)();
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    };
    const handleSearchEnter = ()=>{
        if (debounceInProgress || loading) {
            setSearchClickEvent(true);
        } else {
            var ref, ref1, ref2;
            if (searchResponse === null || searchResponse === void 0 ? void 0 : (ref = searchResponse.data) === null || ref === void 0 ? void 0 : (ref1 = ref.fusion) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.redirect) === null || ref2 === void 0 ? void 0 : ref2[0]) {
                var ref3, ref4;
                window.location.href = searchResponse === null || searchResponse === void 0 ? void 0 : (ref3 = searchResponse.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fusion) === null || ref4 === void 0 ? void 0 : ref4.redirect[0];
                (0,v1_analytics/* addSearchAnalytics */.M)({
                    action: "cmp:click",
                    status: "success",
                    total: 1,
                    autoSearch: false,
                    clear: searchClear,
                    tagger: searchTagger
                }, general, searchKeyword);
            // this means no any requests are in progress. just add click event directly
            }
            (0,v1_analytics/* addSearchAnalytics */.M)({
                action: "cmp:click",
                status: "success",
                total: total,
                autoSearch: false,
                clear: searchClear,
                tagger: searchTagger
            }, general, searchKeyword);
        }
    };
    const setUrlParam = (keyword)=>{
        if (keyword) {
            var ref, ref1;
            sessionStorage.setItem("previousUrl", window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href);
            const url = new URL(window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.href);
            const searchParams = url === null || url === void 0 ? void 0 : url.searchParams;
            let urlSearch = "?" + (searchParams === null || searchParams === void 0 ? void 0 : searchParams.toString());
            if (searchParams.get("keyword") !== (keyword === null || keyword === void 0 ? void 0 : keyword.trim())) {
                urlSearch = "?keyword=".concat(encodeURIComponent(keyword));
            }
            // Debounce URL updates to prevent Safari crashes
            if (window.__urlUpdateTimeout) {
                clearTimeout(window.__urlUpdateTimeout);
            }
            window.__urlUpdateTimeout = setTimeout(()=>{
                try {
                    var ref, ref1;
                    window === null || window === void 0 ? void 0 : (ref = window.history) === null || ref === void 0 ? void 0 : ref.replaceState(window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.pathname, document === null || document === void 0 ? void 0 : document.title, urlSearch);
                } catch (err) {
                    // eslint-disable-next-line no-console
                    console.warn("Failed to update URL:", err.message);
                }
            }, 150) // 150ms debounce
            ;
        }
    };
    const getResults = function(keyword) {
        let brandNameVal = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "kohler", clear = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, tagger = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        const { disableParts  } = staticTexts;
        return new Promise((resolve, reject)=>{
            var ref;
            setLoading(true);
            setDebounceInProgress(false);
            setLoadPopularSearch(false);
            let params = {
                q: keyword,
                rows: 1,
                "lw.tagger.debug": tagDebug,
                collections: brandNameVal,
                displaytype: "search"
            };
            if (isFromServicePart) {
                params = {
                    q: keyword,
                    rows: 1,
                    "lw.tagger.debug": tagDebug,
                    collections: brandNameVal,
                    service: true,
                    displaytype: "search"
                };
            }
            (ref = Promise.all([
                dispatch((0,searchSlice/* fetchSearchAllResults */.w$)({
                    ...params
                })),
                dispatch((0,searchSlice/* fetchSearchServicePartsResults */.mJ)({
                    q: keyword,
                    collections: "service_parts",
                    displaytype: "search"
                }))
            ]).then((resp)=>{
                var ref, ref1;
                const firstResponse = resp[0];
                const firstRespPayload = firstResponse === null || firstResponse === void 0 ? void 0 : firstResponse.payload;
                const firstRespFusion = firstRespPayload === null || firstRespPayload === void 0 ? void 0 : firstRespPayload.fusion;
                const fullCatalogResponse = firstRespFusion === null || firstRespFusion === void 0 ? void 0 : firstRespFusion.full_catalog_Response;
                let isSterlingTemp = false;
                const { redirect: brandFusionRedirect = []  } = firstRespFusion;
                if (brandFusionRedirect && brandFusionRedirect.length > 0) {
                    window.location.href = brandFusionRedirect[0];
                    return;
                }
                if (fullCatalogResponse === null || fullCatalogResponse === void 0 ? void 0 : fullCatalogResponse.length) {
                    if (fullCatalogResponse[0]["Brand_ss"][0] === "Sterling") {
                        isSterlingTemp = true;
                        setIsSterling(true);
                    }
                }
                const isShowEvent = (0,helper/* isShowAnalyticsEventLoaded */.xJ2)();
                const isClickEvent = searchClickEvent;
                if (((ref = resp[0]) === null || ref === void 0 ? void 0 : ref.payload) && ((ref1 = resp[1]) === null || ref1 === void 0 ? void 0 : ref1.payload)) {
                    var ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
                    (0,helper/* addToRecentSearch */.R$3)(keyword);
                    let groups = [
                        {
                            key: "products",
                            count: get_default()((ref2 = resp[0]) === null || ref2 === void 0 ? void 0 : ref2.payload, "facet_counts.facet_fields.Products[1]", 0)
                        },
                        {
                            key: "parts",
                            count: get_default()((ref3 = resp[1]) === null || ref3 === void 0 ? void 0 : ref3.payload, "response.numFound", 0)
                        },
                        {
                            key: "technical",
                            count: get_default()((ref4 = resp[0]) === null || ref4 === void 0 ? void 0 : ref4.payload, "facet_counts.facet_fields.Technical[1]", 0)
                        },
                        {
                            key: "inspiration",
                            count: get_default()((ref5 = resp[0]) === null || ref5 === void 0 ? void 0 : ref5.payload, "facet_counts.facet_fields.Inspiration[1]", 0)
                        },
                        {
                            key: "resource",
                            count: get_default()((ref6 = resp[0]) === null || ref6 === void 0 ? void 0 : ref6.payload, "facet_counts.facet_fields.Resource[1]", 0)
                        },
                        {
                            key: "help",
                            count: get_default()((ref7 = resp[0]) === null || ref7 === void 0 ? void 0 : ref7.payload, "facet_counts.facet_fields.Help[1]", 0)
                        }
                    ];
                    if (disableParts) {
                        groups = groups === null || groups === void 0 ? void 0 : groups.filter((arr)=>{
                            return (arr === null || arr === void 0 ? void 0 : arr.key) !== "parts";
                        });
                    }
                    // Calculating the total results
                    let total = 0;
                    const selected = groups === null || groups === void 0 ? void 0 : groups.find((group)=>{
                        return (group === null || group === void 0 ? void 0 : group.count) > 0;
                    });
                    if (((ref8 = resp[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.payload) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.fusion) === null || ref10 === void 0 ? void 0 : ref10.exactMatch) || ((ref11 = resp[1]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.payload) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.fusion) === null || ref13 === void 0 ? void 0 : ref13.exactMatch)) {
                        var ref21, ref22, ref23, ref24, ref25, ref26;
                        total = (selected === null || selected === void 0 ? void 0 : selected.key) === "parts" ? (ref21 = resp[1]) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.payload) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.response) === null || ref23 === void 0 ? void 0 : ref23.numFound : (ref24 = resp[0]) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.payload) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.response) === null || ref26 === void 0 ? void 0 : ref26.numFound;
                    } else {
                        groups === null || groups === void 0 ? void 0 : groups.map((group)=>{
                            return total += group === null || group === void 0 ? void 0 : group.count;
                        });
                    }
                    if (total === 0) {
                        setLoadPopularSearch(true);
                    }
                    setLoading(false);
                    // setData(resp[0].payload)
                    setPartsData((ref14 = resp[1]) === null || ref14 === void 0 ? void 0 : ref14.payload);
                    setTotal(total);
                    setSelected(selected);
                    setExactMatch((selected === null || selected === void 0 ? void 0 : selected.key) === "parts" ? (ref15 = resp[1]) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.payload) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.fusion) === null || ref17 === void 0 ? void 0 : ref17.exactMatch : (ref18 = resp[0]) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.payload) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.fusion) === null || ref20 === void 0 ? void 0 : ref20.exactMatch);
                    setSearchClickEvent(false);
                    setUrlParam(keyword);
                    const productTabCount = get_default()(resp[0].payload, "facet_counts.facet_fields.Products[1]", 0);
                    const inspireTabCount = get_default()(resp[0].payload, "facet_counts.facet_fields.Inspiration[1]", 0);
                    const technicalTabCount = get_default()(resp[0].payload, "facet_counts.facet_fields.Technical[1]", 0);
                    const resourceTabCount = get_default()(resp[0].payload, "facet_counts.facet_fields.Resource[1]", 0);
                    const helpTabCount = get_default()(resp[0].payload, "facet_counts.facet_fields.Help[1]", 0);
                    const partTabCount = get_default()(resp[1].payload, "response.numFound", 0);
                    const tabCountObj = {
                        productTabCount: isSterlingTemp ? 1 : productTabCount,
                        helpTabCount,
                        resourceTabCount,
                        technicalTabCount,
                        inspireTabCount,
                        partTabCount
                    };
                    setTabResultCounts({
                        [constants.SEARCH_TABS.PRODUCTS]: productTabCount,
                        [constants.SEARCH_TABS.PARTS]: partTabCount,
                        [constants.SEARCH_TABS.INSPIRATION]: inspireTabCount,
                        [constants.SEARCH_TABS.TECHNICAL]: technicalTabCount,
                        [constants.SEARCH_TABS.RESOURCES]: resourceTabCount,
                        [constants.SEARCH_TABS.HELP]: helpTabCount
                    });
                    (0,v1_analytics/* addSearchAnalytics */.M)({
                        action: isClickEvent ? "cmp:click" : "cmp:show",
                        status: "success",
                        total,
                        autoSearch: !isClickEvent && isShowEvent,
                        keyword: keyword,
                        tabCountObj,
                        isSterlingTemp,
                        urlFlag: true,
                        clear: clear,
                        tagger: tagger
                    }, general, searchKeyword);
                    // if the url changes on subsequent searches then log a cmp:show as well
                    if (pageLoadedRef.current) {
                        (0,v1_analytics/* addSearchAnalytics */.M)({
                            action: "cmp:show",
                            status: "success",
                            total,
                            autoSearch: false,
                            keyword: keyword,
                            tabCountObj,
                            isSterlingTemp,
                            searchCountIncreased: false,
                            clear: clear,
                            tagger: tagger
                        }, general, searchKeyword);
                    } else {
                        pageLoadedRef.current = true;
                    }
                    resolve();
                }
            })) === null || ref === void 0 ? void 0 : ref.catch((err)=>{
                var ref;
                // eslint-disable-next-line no-console
                console.log("Error occured while fetching Search data", err);
                const isShowEvent = (0,helper/* isShowAnalyticsEventLoaded */.xJ2)();
                const isClickEvent = searchClickEvent;
                setLoading(false);
                setSearchClickEvent(false);
                setLoadPopularSearch(true);
                (0,v1_analytics/* addSearchAnalytics */.M)({
                    action: isClickEvent ? "cmp:click" : "cmp:show",
                    errorMessage: staticTexts === null || staticTexts === void 0 ? void 0 : (ref = staticTexts.noResults) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                    status: "failure",
                    total: 0,
                    autoSearch: !isClickEvent && isShowEvent,
                    clear: clear,
                    tagger: tagger
                }, general, searchKeyword);
                reject(new Error("something bad happened"));
            });
        });
    };
    const staticData = staticTexts;
    const { disableParts  } = staticData;
    if (((ref = get_default()(searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data, "facet_counts.facet_fields.Products", [])) === null || ref === void 0 ? void 0 : ref.length) > 1 || isSterling && (searchResponse === null || searchResponse === void 0 ? void 0 : (ref1 = searchResponse.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fusion) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.full_catalog_Response) === null || ref3 === void 0 ? void 0 : ref3.length) > 0) {
        var ref4;
        const count = isSterling ? 1 : tabResultCounts[constants.SEARCH_TABS.PRODUCTS];
        tabList === null || tabList === void 0 ? void 0 : tabList.push({
            id: constants.SEARCH_TABS.PRODUCTS,
            title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.products,
            count: count,
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductsTab, {
                staticTexts: staticTexts,
                page: "search",
                type: constants.SEARCH_TABS.PRODUCTS,
                searchKeyword: searchMainKeyword,
                totalSearchResults: isSterling ? 1 : total,
                count: count,
                currencySign: info === null || info === void 0 ? void 0 : info.currencySign,
                onSearch: handleSearch,
                query: 'Products:("ct")',
                lwAppName: general === null || general === void 0 ? void 0 : general.lwAppName,
                componentProps: componentProp,
                presetConfigs: props === null || props === void 0 ? void 0 : (ref4 = props.data) === null || ref4 === void 0 ? void 0 : ref4.presetConfigs,
                marketParamValues: general === null || general === void 0 ? void 0 : general.marketParamValues,
                isSterling: isSterling,
                sterlingData: isSterling && searchResponse.data.fusion.full_catalog_Response,
                showSterlingButton: true,
                brandSwitcherItems: brandSwitcherItems,
                plpBadge: plpBadge,
                brand: general === null || general === void 0 ? void 0 : general.brandName,
                quickViewAuthData: props.quickViewAuthData
            }, constants.SEARCH_TABS.PRODUCTS)
        });
    }
    if (!isSterling) {
        var ref5, ref6, ref7, ref8;
        if (get_default()(partsData, "response.numFound", 0) > 0 && !disableParts) {
            var ref9;
            const count1 = tabResultCounts[constants.SEARCH_TABS.PARTS];
            tabList === null || tabList === void 0 ? void 0 : tabList.push({
                id: constants.SEARCH_TABS.PARTS,
                title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.parts,
                count: count1,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductsTab, {
                    staticTexts: staticTexts,
                    page: "search",
                    type: constants.SEARCH_TABS.PARTS,
                    count: count1,
                    searchKeyword: searchMainKeyword,
                    totalSearchResults: total,
                    currencySign: info === null || info === void 0 ? void 0 : info.currencySign,
                    onSearch: handleSearch,
                    productsPerPage: productsPerPage,
                    componentProps: componentProp,
                    presetConfigs: props === null || props === void 0 ? void 0 : (ref9 = props.data) === null || ref9 === void 0 ? void 0 : ref9.presetConfigs,
                    marketParamValues: general === null || general === void 0 ? void 0 : general.marketParamValues,
                    isSterling: isSterling,
                    sterlingData: isSterling && searchResponse.data.fusion.full_catalog_Response,
                    lwAppName: general === null || general === void 0 ? void 0 : general.lwAppName,
                    brand: general === null || general === void 0 ? void 0 : general.brandName,
                    quickViewAuthData: props.quickViewAuthData
                }, constants.SEARCH_TABS.PARTS)
            });
        }
        if (((ref5 = get_default()(searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data, "facet_counts.facet_fields.Inspiration", [])) === null || ref5 === void 0 ? void 0 : ref5.length) > 1) {
            const count2 = tabResultCounts[constants.SEARCH_TABS.INSPIRATION];
            tabList === null || tabList === void 0 ? void 0 : tabList.push({
                id: constants.SEARCH_TABS.INSPIRATION,
                title: staticTexts.inspiration,
                count: count2,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationTab/* default */.Z, {
                    page: "search",
                    type: constants.SEARCH_TABS.INSPIRATION,
                    searchKeyword: searchMainKeyword,
                    totalResults: count2,
                    totalSearchResults: total,
                    displayShare: true,
                    displayPrint: true,
                    onSearch: handleSearch,
                    productsPerPage: productsPerPage,
                    fquery: 'Inspiration:("Inspiration")',
                    staticTexts: staticTexts,
                    knowledgeArticleUrl: info === null || info === void 0 ? void 0 : info.knowledgeArticleUrl,
                    marketParamValues: general === null || general === void 0 ? void 0 : general.marketParamValues,
                    brand: general === null || general === void 0 ? void 0 : general.brandName
                }, constants.SEARCH_TABS.INSPIRATION)
            });
        }
        if (((ref6 = get_default()(searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data, "facet_counts.facet_fields.Technical", [])) === null || ref6 === void 0 ? void 0 : ref6.length) > 1) {
            const count3 = tabResultCounts[constants.SEARCH_TABS.TECHNICAL];
            tabList === null || tabList === void 0 ? void 0 : tabList.push({
                id: constants.SEARCH_TABS.TECHNICAL,
                title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.technical,
                count: count3,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_TechnicalTab, {
                    page: "search",
                    staticTexts: staticTexts,
                    type: constants.SEARCH_TABS.TECHNICAL,
                    count: count3,
                    searchKeyword: searchMainKeyword,
                    totalSearchResults: total,
                    displayShare: true,
                    displayPrint: true,
                    onSearch: handleSearch,
                    productsPerPage: productsPerPage,
                    totalResults: total,
                    marketParamValues: general === null || general === void 0 ? void 0 : general.marketParamValues,
                    brand: general === null || general === void 0 ? void 0 : general.brandName
                }, constants.SEARCH_TABS.TECHNICAL)
            });
        }
        if (((ref7 = get_default()(searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data, "facet_counts.facet_fields.Resource", [])) === null || ref7 === void 0 ? void 0 : ref7.length) > 1) {
            const count4 = tabResultCounts[constants.SEARCH_TABS.RESOURCES];
            tabList === null || tabList === void 0 ? void 0 : tabList.push({
                id: constants.SEARCH_TABS.RESOURCES,
                title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.resource,
                count: count4,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationTab/* default */.Z, {
                    page: "search",
                    type: constants.SEARCH_TABS.RESOURCES,
                    searchKeyword: searchMainKeyword,
                    totalResults: count4,
                    totalSearchResults: total,
                    displayShare: true,
                    displayPrint: true,
                    onSearch: handleSearch,
                    productsPerPage: productsPerPage,
                    fquery: 'Resource:("Resource")',
                    staticTexts: staticTexts,
                    knowledgeArticleUrl: info.knowledgeArticleUrl,
                    brand: general === null || general === void 0 ? void 0 : general.brandName
                }, constants.SEARCH_TABS.RESOURCES)
            });
        }
        if (((ref8 = get_default()(searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data, "facet_counts.facet_fields.Help", [])) === null || ref8 === void 0 ? void 0 : ref8.length) > 1) {
            const count5 = tabResultCounts[constants.SEARCH_TABS.HELP];
            tabList === null || tabList === void 0 ? void 0 : tabList.push({
                id: constants.SEARCH_TABS.HELP,
                title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.help,
                count: count5,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationTab/* default */.Z, {
                    page: "search",
                    staticTexts: staticTexts,
                    type: constants.SEARCH_TABS.HELP,
                    searchKeyword: searchMainKeyword,
                    totalResults: count5,
                    onSearch: handleSearch,
                    productsPerPage: productsPerPage,
                    fquery: 'Help:("sf")',
                    knowledgeArticleUrl: info.knowledgeArticleUrl,
                    totalSearchResults: total,
                    displayShare: true,
                    displayPrint: true,
                    brand: general === null || general === void 0 ? void 0 : general.brandName
                }, constants.SEARCH_TABS.HELP)
            });
        }
    }
    const currentTab = (0,helper/* getParamFromUrl */.LjC)("tab") || "";
    if (currentTab) activeTab = tabList === null || tabList === void 0 ? void 0 : tabList.findIndex((tab)=>{
        return (tab === null || tab === void 0 ? void 0 : tab.id) === currentTab;
    });
    else {
        if (get_default()(searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data, "fusion.default_tab[0]", "")) {
            activeTab = tabList === null || tabList === void 0 ? void 0 : tabList.findIndex((tab)=>{
                var ref, ref1;
                return (tab === null || tab === void 0 ? void 0 : tab.id) === (searchResponse === null || searchResponse === void 0 ? void 0 : (ref = searchResponse.data) === null || ref === void 0 ? void 0 : (ref1 = ref.fusion) === null || ref1 === void 0 ? void 0 : ref1.default_tab[0]);
            });
        }
    }
    if (exactMatch) tabList === null || tabList === void 0 ? void 0 : tabList.forEach((tab, index)=>{
        if ((tab === null || tab === void 0 ? void 0 : tab.id) !== (selected === null || selected === void 0 ? void 0 : selected.key)) {
            tabList === null || tabList === void 0 ? void 0 : tabList.splice(1, index);
        }
    });
    if (((searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data) || (searchKeyword === null || searchKeyword === void 0 ? void 0 : searchKeyword.length) < 2) && !loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchView, {
                activeTabVal: activeTab,
                loading: loading,
                data: componentProp,
                staticTexts: staticTexts,
                totalResults: isSterling ? 1 : total,
                searchKeyword: searchKeyword,
                tabList: tabList,
                selected: selected,
                exactMatch: exactMatch,
                onSearch: handleSearch,
                brand: general === null || general === void 0 ? void 0 : general.brandName,
                handleSearchEnter: handleSearchEnter,
                staticData: staticData,
                loadPopularSearch: loadPopularSearch,
                searchResponse: searchResponse,
                isSterling: isSterling
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_OuterSearchProgressive, {});
    }
};
/* harmony default export */ var Search = (SearchComponent);

// EXTERNAL MODULE: ./components/Default/BreadCrumb.jsx
var BreadCrumb = __webpack_require__(3282);
;// CONCATENATED MODULE: ./pages/search.jsx

















/**
 * renders home page
 * @return {JSX.Element}
 * @param {object} props The props.
 */ const search_Search = (props)=>{
    const { tmpData: data , headertmp: header , footertmp: footer , ip , adobeAnalytic , globalScript , footerScript , analyticsData , datalayerPageName , gbhDataLayerCustom  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const { cartUrl  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const { brandLogoImg , menu: { isOpen , mainCategoryActive , isRegionOpen , isAuthNavOpen  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    (0,react.useEffect)(()=>{
        if (ip) sessionStorage.setItem("true-ip", ip);
    }, [
        ip
    ]);
    (0,usePageAuth/* default */.Z)();
    const cartCount = (0,cart/* getCartCount */.c0)();
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const ariaLabel = (0,cart/* getAriaLabel */.Xw)(t, cartCount);
    (0,react.useEffect)(()=>{
        (0,helper/* getScriptsAndStyles */.csL)(footer);
    }, [
        footer
    ]);
    (0,react.useEffect)(()=>{
        (0,helper/* getAnalyticsScript */.Szq)(adobeAnalytic);
    }, [
        adobeAnalytic
    ]);
    (0,react.useEffect)(()=>{
        (0,helper/* getDataLayerObj */.C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react.useEffect)(()=>{
        dispatch((0,genericSlice/* setDatalayerPageName */.dN)(datalayerPageName));
        dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        return ()=>{
            dispatch((0,genericSlice/* setDatalayerPageName */.dN)(""));
            dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
        };
    }, []);
    const toggleMenu = ()=>{
        if (isOpen) {
            dispatch((0,genericSlice/* closeMenu */.Wj)());
            dispatch((0,genericSlice/* setAuthNav */.AT)(false));
        } else {
            dispatch((0,genericSlice/* openMenu */.qn)());
        }
    };
    const redirect = ()=>{
        router.push("".concat(cartUrl));
    };
    const eventHandler = {
        store: {
            brandLogoImg: brandLogoImg,
            isOpen,
            mainCategoryActive,
            isRegionOpen,
            isAuthNavOpen,
            cartCount,
            ariaLabel,
            cartUrl
        },
        callbacks: {
            setBrandLogoImg: (path)=>{
                dispatch((0,genericSlice/* setBrandLogoImg */.XY)(path));
            },
            closeMenu: ()=>{
                dispatch((0,genericSlice/* closeMenu */.Wj)());
            },
            setMainCategory: (payload)=>{
                dispatch((0,genericSlice/* setActiveMainCategory */.X7)(payload));
            },
            toggleMenu: ()=>{
                toggleMenu();
            },
            setRegionNav: (active)=>{
                dispatch((0,genericSlice/* setRegionNav */.qX)(active));
            },
            setAuthNav: (active)=>{
                dispatch((0,genericSlice/* setAuthNav */.AT)(active));
            },
            setGlobalScripts: (item)=>{
                dispatch((0,genericSlice/* setGlobalScripts */.n8)(item));
            },
            setGlobalStyles: (item)=>{
                dispatch((0,genericSlice/* setGlobalStyles */.cw)(item));
            },
            onClick: ()=>{
                redirect();
            }
        }
    };
    const quickViewAuthData = (0,helper/* getQuickViewAuth */.sKe)(footer);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader["default"], {
                themeType: data === null || data === void 0 ? void 0 : data.appliedCssClassNames,
                header: header,
                title: data.title,
                globalScripting: globalScript,
                data: data
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: data.id,
                className: data.cssClassNames,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid["default"], {
                    data: data,
                    count: 0,
                    eventHandler: eventHandler,
                    breadCrumb: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumb["default"], {
                            data: data
                        }),
                    searchComponent: (data, eventHandler)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {
                            data: data,
                            eventHandler: eventHandler,
                            header: header,
                            quickViewAuthData: quickViewAuthData
                        }),
                    searchFiller: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_OuterSearchProgressive, {
                            data: data
                        })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter["default"], {
                footer: footer,
                footerScripting: footerScript
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var search = (search_Search);


/***/ }),

/***/ 28763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/factory/factory.utils.mjs
var factory_utils = __webpack_require__(99347);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Flex/Flex.mjs + 2 modules
var Flex = __webpack_require__(54112);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/Grid.mjs + 1 modules
var Grid = __webpack_require__(40697);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Layout/Grid/GridColumn/GridColumn.mjs + 1 modules
var GridColumn = __webpack_require__(57237);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Other/Box/Box.mjs + 1 modules
var Box = __webpack_require__(3253);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Navigation/Breadcrumb/Breadcrumb.module.css.mjs
var classes = {
    "root": "_2RDNi",
    "linkTransparent": "-qI-7",
    "iconTransparent": "_8MHP9",
    "iconDefault": "pLn5u",
    "rootTransparent": "STCP7",
    "breadcrumbWrapper": "_947CK",
    "breadcrumbWrapperMedium": "oOLmK",
    "breadcrumbWrapperSmall": "_7Dija",
    "breadcrumbWrapperXSmall": "zNTEZ",
    "breadcrumbLinkWrapper": "XtR2b",
    "iconButton": "_0cVhp"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Navigation/Breadcrumb/Breadcrumb.utils.mjs

const breadcrumbSizeClasses = {
    xSmall: classes.breadcrumbWrapperXSmall,
    small: classes.breadcrumbWrapperSmall,
    default: classes.breadcrumbWrapperMedium
};
function isActionIconObject(item) {
    return typeof item === "object" && item !== null && "icon" in item && "action" in item;
}


// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Foundations/Typography/Typography.mjs + 2 modules
var Typography = __webpack_require__(72905);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/utils/helpers.mjs
var helpers = __webpack_require__(37892);
;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Navigation/Breadcrumb/BreadcrumbLink/BreadcrumbLink.module.css.mjs
var BreadcrumbLink_module_css_classes = {
    "breadcrumbLink": "xcyf9",
    "transparentBreadcrumbLink": "_2ME8v",
    "photoBreadcrumbLink": "sFDxw"
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Navigation/Breadcrumb/BreadcrumbLink/BreadcrumbLink.mjs





const BreadcrumbLink = (param)=>{
    let { breadcrumb , transparent  } = param;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Typography/* Typography */.Z, {
        size: "label-regular-s",
        component: "a",
        key: breadcrumb.href,
        ...(0,helpers/* omitText */.rW)(breadcrumb),
        className: (0,clsx/* default */.Z)(BreadcrumbLink_module_css_classes.breadcrumbLink, !transparent ? BreadcrumbLink_module_css_classes.transparentBreadcrumbLink : BreadcrumbLink_module_css_classes.photoBreadcrumbLink)
    }, breadcrumb.text);
};


;// CONCATENATED MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Navigation/Breadcrumb/Breadcrumb.mjs










const Breadcrumb = (0,factory_utils/* polymorphicFactory */.bq)((props, ref)=>{
    const { breadcrumbs , actionIcons , component ="div" , className , transparent =false , size ="default" , ...rest } = props;
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Grid/* Grid */.r, {
        component,
        ref,
        ...rest,
        className: (0,clsx/* default */.Z)(classes.root, "kohler-breadcrumbs-root", className, transparent && classes.rootTransparent)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(GridColumn/* GridColumn */.C, {
        className: (0,clsx/* default */.Z)(breadcrumbSizeClasses[size], classes.breadcrumbWrapper, transparent && classes.linkTransparent)
    }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        component: "ul",
        className: classes.breadcrumbLinkWrapper
    }, breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.map((breadcrumb)=>/* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
            component: "li",
            key: breadcrumb.text,
            align: "center"
        }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(BreadcrumbLink, {
            breadcrumb,
            transparent
        })))), actionIcons && /* @__PURE__ */ /*#__PURE__*/ react.createElement(Flex/* Flex */.k, {
        className: transparent ? classes.iconTransparent : classes.iconDefault
    }, actionIcons.map((item, index)=>{
        if (!item) return null;
        if (/*#__PURE__*/ react.isValidElement(item)) {
            return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, {
                key: "breadcrumb-node-".concat(index)
            }, item);
        }
        if (isActionIconObject(item)) {
            const ActionIcon = item.icon;
            return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Box/* Box */.x, {
                ...item.action,
                component: "button",
                type: "button",
                textColor: "inherit",
                key: "breadcrumb-icon-".concat(index),
                className: classes.iconButton
            }, /* @__PURE__ */ /*#__PURE__*/ react.createElement(ActionIcon, {
                type: "icon",
                size: "medium",
                withBoundingBox: true
            }));
        }
        return /* @__PURE__ */ /*#__PURE__*/ react.createElement(react.Fragment, {
            key: "breadcrumb-unknown-".concat(index)
        }, item);
    }))));
});



/***/ }),

/***/ 62860:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchViewStyleWrapper":"SearchView_searchViewStyleWrapper__IBVCz"};

/***/ }),

/***/ 25043:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ g; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var h = Object.defineProperty;
var u = (n, t, e) => t in n ? h(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var c = (n, t, e) => (u(n, typeof t != "symbol" ? t + "" : t, e), e);

const p = (n, t) => typeof getComputedStyle < "u" ? getComputedStyle(n, null).getPropertyValue(t) : n.style.getPropertyValue(t), y = (n) => p(n, "overflow") + p(n, "overflow-y") + p(n, "overflow-x"), w = (n) => {
  if (!(n instanceof HTMLElement))
    return window;
  let t = n;
  for (; t && !(t === document.body || t === document.documentElement || !t.parentNode); ) {
    if (/(scroll|auto)/.test(y(t)))
      return t;
    t = t.parentNode;
  }
  return window;
};
class g extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(e) {
    super(e);
    c(this, "elementObserver");
    c(this, "wrapper");
    c(this, "lazyLoadHandler", (e) => {
      var o, i;
      const {
        onContentVisible: s
      } = this.props, [r] = e, {
        isIntersecting: l
      } = r;
      if (l) {
        this.setState({
          visible: !0
        }, () => {
          s && s();
        });
        const a = (o = this.wrapper) == null ? void 0 : o.current;
        a && a instanceof HTMLElement && ((i = this.elementObserver) == null || i.unobserve(a));
      }
    });
    this.elementObserver = null, this.wrapper = react__WEBPACK_IMPORTED_MODULE_0__.createRef(), this.state = {
      visible: !1
    };
  }
  componentDidMount() {
    var o;
    this.getEventNode();
    const {
      offset: e,
      threshold: s
    } = this.props, r = {
      rootMargin: typeof e == "number" ? `${e}px` : e || "0px",
      threshold: s || 0
    };
    this.elementObserver = new IntersectionObserver(this.lazyLoadHandler, r);
    const l = (o = this.wrapper) == null ? void 0 : o.current;
    l instanceof HTMLElement && this.elementObserver.observe(l);
  }
  shouldComponentUpdate(e, s) {
    return s.visible;
  }
  componentWillUnmount() {
    var s, r;
    const e = (s = this.wrapper) == null ? void 0 : s.current;
    e && e instanceof HTMLElement && ((r = this.elementObserver) == null || r.unobserve(e));
  }
  getEventNode() {
    var e;
    return w((e = this.wrapper) == null ? void 0 : e.current);
  }
  render() {
    const {
      children: e,
      className: s,
      height: r,
      width: l,
      elementType: o
    } = this.props, {
      visible: i
    } = this.state, a = {
      height: r,
      width: l
    }, d = `LazyLoad${i ? " is-visible" : ""}${s ? ` ${s}` : ""}`;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(o || "div", {
      className: d,
      style: a,
      ref: this.wrapper
    }, i && react__WEBPACK_IMPORTED_MODULE_0__.Children.only(e));
  }
}
c(g, "defaultProps", {
  elementType: "div",
  className: "",
  offset: 0,
  threshold: 0,
  width: null,
  onContentVisible: null,
  height: null
});



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [361,2857,2247,5726,1976,2710,7783,772,5979,4751,6687,5266,3838,9774,2888,179], function() { return __webpack_exec__(32252); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);